import React, { Component } from 'react';
import './test-list.scss';
import { Modal, ModalBody, Tooltip } from "reactstrap";
import { AccessRights, Constants, ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import Utility from '../../../utility/common-utilities'
import Filter from './filter/filter'
import TestResultReport from '../reports/test-results/test-results'
import TestApi from '../../../apis/test'
import NewTest from '../new-test/new-test'
import Path from '../../routes/routes-path';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap-daterangepicker/daterangepicker.css';
import CompletionReport from '../reports/completion-report/completion-report'
import WronglyAnswered from '../../common/wrong-answers-modal/wrong-answers-modalV1/wrong-answers-modal'
import AllQuestions from '../reports/all-questions/all-questions'
import QustionsList from '../reports/questions-list/all-questions'
import ReactTooltip from 'react-tooltip';
import ArchiveModal from '../../common/archive/archive'
import ReminderModel from './reminder/reminder'
import NotificationModel from './notification/notification'
import SessionCache from '../../routes/session-cache';
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import SuccessComponent from './success/success';
import moment from 'moment';
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';
import ActiveHomeworkModal from '../../common/active-homework/active-homework';
import EloReport from '../reports/elo-report/elo-report';
import RecommandationReport from '../reports/recommandation-report/recommandation-report';
import HomeworkApi from '../../../apis/homework';
import JigyasaAssessment from '../../clicker-assessment-experience/jigyasa-assessment';
import CommonApi from '../../../apis/common';
import DiagnosticAssessmentReport from '../../student-performance-report/diagnostic-assessment-report-v1/diagnostic-assessment-report';
import Loading from '../../common/loading/loading';
import LayoutShared from '../../common/layout-shared/layout-shared';
import CommonUtils from '../../../utility/common-utilities';
import StudentNameList from '../../clicker-flow-practice-v3/clicker-flow-practice-list/student-name-list/student-name-list';
import ClickerTesting from '../../clicker-flow-practice-v3/clicker-flow-practice-list/clicker-testing/clicker-testing';
import IndexedDBHelperV2 from "../../../offline/apis/indexDBManager-v2";
import ClassPerformanceReport from './class-performance-report/class-performance-report';
import HomeworkForClickerPracticeApi from '../../../apis/homework-for-clicker-practice';
import ExcelJS from "exceljs";
import SchoolworkOverallClassPerformanceReport from '../../clicker-flow-practice-v3/clicker-flow-practice-list/schoolwork-class-performance-report/overall-class-performance-report';
import ViewAssessmentSummary from '../view-assessment-summary/new-test';
import SchoolApi from '../../../apis/school';
import AssignmentDeletionComponent from '../../common/assignment-deletion-modal/archive';
let { Parser } = require('json2csv');

const dbHelper = new IndexedDBHelperV2(Constants.DB_NAME, Constants.DB_VERSION, Constants.STORE_CONFIG);

class TestList extends Component {

    state = {
        testList: [],
        tabs: [
            { title: "My Activities", value: "ACTIVE" },
            { title: "Active", value: "ACTIVE" },
            { title: "Completed", value: "COMPLETED" },
            // { title: "Archived", value: "ARCHIVED" }
        ],
        activeTabIndex: 0,
        copiedId: null,
        selectedFilters: [],
        userInfo: {},
        type: "CLICKER_ASSESSMENT",
        showDiagnosticAssessmentReport: false,
        categories: [
            {
                type: "NOVICE",
                title: "Novice",
                maxPercentage: 50,
                students: [],
                colorClass: "purble-header",
                selectedCriterion: 1
            },
            {
                type: "PROFICIENT",
                title: "Proficient",
                minPercentage: 50,
                maxPercentage: 80,
                students: [],
                colorClass: "orange-header",
                selectedCriterion: 1
            },
            {
                type: "ADVANCED",
                title: "Advanced",
                minPercentage: 80,
                students: [],
                colorClass: "litebule-header",
                selectedCriterion: 1
            }
        ],
        levels: [
            {
                type: "NOVICE",
                title: "Novice",
                subTitle: '<50%',
                students: [
                ]
            },
            {
                type: "PROFICIENT",
                title: "Proficient",
                subTitle: '50% - 80%',
                students: []
            },
            {
                type: "ADVANCE",
                title: "Advance",
                subTitle: '>80%',
                students: []
            }
        ],
        isLoading: false,
    }

    limit = 10
    filter = { status: "ACTIVE" }

    skillList = [
        {
            type: "KNOWLEDGE",
            title: "KNOWLEDGE - Ability to remember formulas",
            image: ImageConstants.KNOWLEDGE,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "CALCULATION",
            title: "CALCULATION - Ability to Calculate",
            image: ImageConstants.CALCULATION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "MODELING",
            title: "MODELING - Ability to get Logic & form equation",
            image: ImageConstants.MODELING,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        },
        {
            type: "COMPREHENSION",
            title: "COMPREHENSION - Ability to Understand the Language",
            image: ImageConstants.COMPREHENSION,
            masteredPercentage: 0,
            mastered: 0,
            needImprovement: 0,
            needImprovementPercentage: 0
        }]

    orderedSkills = ["knowledge", "calculation", "modeling", "comprehension"]


    accessRights = SessionCache.getAllowedModule()
    constructor(props) {
        super(props)
        if (this.props.filter) {
            this.filter = {
                status: "ACTIVE",
                board: this.props.filter?.board || "",
                class: this.props.filter?.class || "",
                chapter: this.props.filter?.chapterKey || "",

            }
        }
        this.layoutShared = LayoutShared.getLayout()
        if (this.props.type) this.filter.type = this.props.type
    }

    teacherHomeworkActivityStatusHash = {}

    componentDidMount() {
        this.getTeacherHomeworkActivities()
        let userInfo = SessionCache.getUser()
        console.log(userInfo)
        this.setState({ userInfo })

        console.log(this.layoutShared.state.homeworkItem)

        if (!CommonUtils.isOnline() && this.layoutShared.state.homeworkItem &&
            this.layoutShared.state.homeworkItem.homeworkId &&
            this.layoutShared.state.homeworkItem.status != 'COMPLETED') {
            setTimeout(() => {
                this.onClickCard(this.layoutShared.state.homeworkItem)
            }, 500)

        }

        // if (!CommonUtils.isOnline() && this.layoutShared.state.homeworkItem &&
        //     this.layoutShared.state.homeworkItem._id &&
        //     this.layoutShared.state.homeworkItem.teacherHomeworkActivityStatus != 'COMPLETED' &&
        //     this.layoutShared.state.homeworkItem.isEndPractice) {
        //     setTimeout(() => {
        //         this.onClickEndPractice(this.layoutShared.state.homeworkItem)
        //     }, 1000)
        // }


    }



    getTestList(payload = {}) {

        if (!payload.page) payload.page = this.state.selectedPage || 1
        if (!payload.limit) payload.limit = this.limit

        this.currentPage = payload.page
        payload.type = "CLICKER_ASSESSMENT"

        if (this.currentPage === 1) this.startIndex = 1

        if (CommonUtils.isOnline()) {
            this.setState({ isLoading: true, meta: {} })
            TestApi.getTest(payload)
                .then(response => {
                    console.log(response.response)
                    this.buildTestList(response.response)
                    this.setState({ meta: response?.meta, totalpages: response?.meta?.count, isLoading: false })
                }).catch(err => {
                    this.setState({ isLoading: false })
                })

        } else if (!CommonUtils.isOnline()) {

            let userInfo = SessionCache.getUser()

            if (userInfo && userInfo.schoolInfo && userInfo.schoolInfo.schoolCode) {
                dbHelper.getAllFromIndex(Constants.HOMEWORK_STORE, 'schoolId', userInfo.schoolInfo.schoolCode).then(res => {
                    console.log(res)
                    res = res.sort((a, b) => new Date(b.createdDateTimestamp) - new Date(a.createdDateTimestamp))
                    res = res.filter(item => item.type === 'CLICKER_ASSESSMENT')
                    console.log(res)
                    this.buildTestList(res)
                    this.setState({ isLoading: false })
                }).catch(err => {
                    console.log(err)
                })
            } else {
                dbHelper.getAllFromIndex(Constants.HOMEWORK_STORE, 'type', 'CLICKER_ASSESSMENT').then(res => {
                    console.log(res)

                    res = res.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))
                    this.buildTestList(res)
                    this.setState({ isLoading: false })
                }).catch(err => {
                    console.log(err)
                })
            }

        }


    }

    getTeacherHomeworkActivities() {
        let payload = {}

        payload.type = ["CLICKER_ASSESSMENT"]

        if (CommonUtils.isOnline()) {
            HomeworkApi.getTeacherHomeworkActivities(payload).then(res => {
                console.log(res)

                dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'type', 'CLICKER_ASSESSMENT').then(localRes => {
                    // console.log(localRes)

                    let homeworkListHash = {}

                    localRes.forEach(item => homeworkListHash[item._id] = item)
                    if (res.contents.length > 0) {
                        let completedHomework = [], notCompletedHomework = []
                        res.contents.forEach(item => {
                            if (item.status === 'COMPLETED') {
                                completedHomework.push(item)
                            } else {
                                notCompletedHomework.push(item)
                            }

                            if (homeworkListHash[item._id]) {
                                console.log(homeworkListHash[item._id].status)
                                // item.status = homeworkListHash[item._id].status
                                // item.pendingSync = homeworkListHash[item._id].pendingSync ? homeworkListHash[item._id].pendingSync : false
                                item.status = item.status === 'COMPLETED' ? 'COMPLETED' : homeworkListHash[item._id].status
                                // item.pendingSync = item.status === 'COMPLETED' && homeworkListHash[item._id].isDownloaded ? true : homeworkListHash[item._id].pendingSync ? homeworkListHash[item._id].pendingSync : false
                                item.pendingSync = homeworkListHash[item._id].pendingSync ? homeworkListHash[item._id].pendingSync : false
                                if (homeworkListHash[item._id].selectedSetId) {
                                    item.selectedSetId = homeworkListHash[item._id].selectedSetId
                                    item.selectedSetTitle = homeworkListHash[item._id].selectedSetTitle
                                }
                            }
                            this.teacherHomeworkActivityStatusHash[item.homeworkId] = item
                        })
                        this.setState({ content: res.contents, completedHomework, notCompletedHomework, isReload: true }, () => {
                            this.getTestList(this.filter)
                        })
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        } else if (!CommonUtils.isOnline()) {

            let userInfo = SessionCache.getUser()

            if (userInfo && userInfo.schoolInfo && userInfo.schoolInfo.schoolCode) {
                dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'schoolId', userInfo.schoolInfo.schoolCode).then(res => {

                    console.log(res)

                    res = res.sort((a, b) => new Date(b.countingwellCreatedTimestamp) - new Date(a.countingwellCreatedTimestamp))

                    res.forEach(item => {
                        this.teacherHomeworkActivityStatusHash[item.homeworkId] = item
                    })

                    res = res.filter(item => item.type === 'CLICKER_ASSESSMENT')



                    console.log(res)

                    this.setState({ content: res }, () => {
                        this.getTestList(this.filter)
                    })
                }).catch(err => {
                    console.log(err)
                })
            } else {
                dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'type', 'CLICKER_ASSESSMENT').then(res => {
                    console.log(res)

                    res = res.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))

                    res.forEach(item => {
                        this.teacherHomeworkActivityStatusHash[item.homeworkId] = item
                    })



                    this.setState({ content: res }, () => {
                        this.getTestList(this.filter)
                    })
                }).catch(err => {
                    console.log(err)
                })
            }
        }


    }


    handleDateEvent = (event, picker, item, index) => {
        this.dueDate = picker.startDate ? (new Date(new Date(picker.startDate).setHours(23, 59, 59, 999)).toISOString()) : ''

        let payload = { testId: item._id, dueDate: this.dueDate, }
        TestApi.updateTest(payload)
            .then(response => {
                this.getTestList(this.filter)
            }).catch(err => {
            })
    }


    buildTestList(tests) {
        console.log(tests)
        let testList = []
        for (let i = 0; i < tests.length; i++) {
            let test = tests[i]
            if (this.teacherHomeworkActivityStatusHash[test._id]) {
                let obj = {
                    _id: test._id,
                    createdDate: new Date(test.createdDateTimestamp || test.createdDate || test.countingwellCreatedTimestamp).toLocaleDateString("en-IN"),
                    // createdDateTimestamp: test.countingwellCreatedTimestamp,
                    createdDateTimestamp: CommonUtils.isOnline() ? test.countingwellCreatedTimestamp : test.createdDateTimestamp,
                    dueDate: new Date(test.endDate).toLocaleDateString("en-IN"),
                    chapters: test?.chapters,
                    chapter: test?.chapters[0].title,
                    chapterKey: test?.chapters[0].key,
                    class: test.class,
                    section: test.section,
                    sectionId: test.sectionId ? test.sectionId : '',
                    time: test.duration ? test.duration : test.time ? test.time : 0,
                    questions: test.questionIds ? test.questionIds.length : test.questions ? test.questions : 0,
                    completed: test.completed,
                    notCompleted: test.notCompleted,
                    notificationCount: test.notificationCount,
                    lastNotificationSentDate: test.lastNotificationSentDate,
                    type: test.type,
                    users: test.users || [],
                    basePath: test.basePath,
                    status: test.status,
                    board: test.board,
                    selectedSetId: test.selectedSetId ? test.selectedSetId : '',
                    selectedSetTitle: test.selectedSetTitle,
                    masterDataId: test.masterDataId,
                    schoolAssessmentId: test.schoolAssessmentId ? test.schoolAssessmentId : '',
                    autoNext: test.autoNext ? test.autoNext : false,
                    totalMarks: test.totalMarks ? test.totalMarks : 0
                    // teacherHomeworkActivityStatus: this.teacherHomeworkActivityStatusHash[test._id].status
                }


                if (this.teacherHomeworkActivityStatusHash[test._id]) {
                    obj.teacherHomeworkActivityStatus = this.teacherHomeworkActivityStatusHash[test._id].status
                    obj.teacherHomeworkActivityId = this.teacherHomeworkActivityStatusHash[test._id]._id
                    obj.isDownloaded = this.teacherHomeworkActivityStatusHash[test._id].isDownloaded
                    obj.pendingSync = this.teacherHomeworkActivityStatusHash[test._id].pendingSync
                    obj.clickerSet = this.teacherHomeworkActivityStatusHash[test._id].clickerSet
                    obj.isStudentBulkReportGenerationDone = this.teacherHomeworkActivityStatusHash[test._id].isStudentBulkReportGenerationDone ? true : false
                    obj.countingwellLastUpdateTimestamp = this.teacherHomeworkActivityStatusHash[test._id].countingwellLastUpdateTimestamp
                    obj.resumeQuestionNumber = this.teacherHomeworkActivityStatusHash[test._id].resumeQuestionNumber ? this.teacherHomeworkActivityStatusHash[test._id].resumeQuestionNumber : 0
                }

                if (this.teacherHomeworkActivityStatusHash[test._id].isDownloaded) {
                    obj.selectedSetTitle = this.teacherHomeworkActivityStatusHash[test._id].selectedSetTitle
                }

                if (this.state.userInfo.subjectId === Constants.SCIENCE_SUBJECTID) {
                    obj.subSubjectId = test.subSubjectId
                    obj.subSubjectName = test.subSubjectName

                    if (test.clickerAssessmentTitle) {
                        obj.clickerAssessmentTitle = test.clickerAssessmentTitle
                    }

                }

                if (test.clickerAssessmentTitle) {
                    obj.clickerAssessmentTitle = test.clickerAssessmentTitle
                }

                testList.push(obj)
            }

        }

        console.log(testList)
        this.setState({ testList })

    }

    downloadClassPerformanceExcelReport = (type, item, index, grpIndex) => {
        // this.setState({ selectedHomework: item, selectedItemIndex: index, selectedItemGroupIndex: grpIndex })
        console.log(item)

        let payload = {
            homeworkId: item._id,
            classText: item.class,
            board: item.board,
            type: item.type,
            sectionId: item.sectionId,
            section: item.section,
            masterDataId: item.masterDataId,
            duration: item.approximateTime,
            chapterKey: item.chapterKey
        }

        this.setState({ isLoading: true })

        HomeworkForClickerPracticeApi.getClassPerformanceReport(payload).then(res => {
            console.log(res)

            this.onClickExportClassPerformanceExcelReport(res, item)
            this.setState({ isLoading: false })

        }).catch(err => {
            console.log(err)
        })

    }


    onClickExportClassPerformanceExcelReport = async (classPerformanceData, selectedItem) => {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Student Report");

        // Header
        sheet.mergeCells("A1:D1");
        sheet.getCell("A1").value = "Summary";
        sheet.getCell("A1").font = { bold: true, size: 14 };
        sheet.getCell("A1").alignment = { horizontal: "center" };
        sheet.getCell("A1").fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4AB7E7" }, // Blue background
        };



        // Info section
        // sheet.addRow([]);
        sheet.addRow(["Class", `${selectedItem.class.split(' ')[1]}${selectedItem.section}`]);
        sheet.addRow(["Date", this.getDate(selectedItem.createdDateTimestamp, true)]);
        sheet.addRow(["Chapter", selectedItem.chapters[0].title]);
        sheet.addRow(["Duration", selectedItem.time + 'mins']);
        sheet.addRow(["Total Mark", selectedItem.totalMarks]);
        // sheet.addRow([]);


        // sheet.mergeCells("A6:D6");
        // sheet.getCell("A6").value = "Summary";
        // sheet.getCell("A6").font = { bold: true, size: 14 };
        // sheet.getCell("A6").alignment = { horizontal: "center" };
        // sheet.getCell("A6").fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "4AB7E7" }, // Blue background
        // };

        sheet.addRow(["Total Questions", `${selectedItem.questions}`]);
        sheet.addRow(["Total Students", classPerformanceData.summary.totalStudents]);
        sheet.addRow(["Total Attempted", classPerformanceData.summary.totalCompletedStudents]);
        sheet.addRow(["% Accuracy", classPerformanceData.summary.accuracyPercentage + '%']);
        sheet.addRow([]);


        sheet.mergeCells("A11:E11");
        sheet.getCell("A11").value = "Student Performance Details";
        sheet.getCell("A11").font = { bold: true, size: 14 };
        sheet.getCell("A11").alignment = { horizontal: "center" };
        sheet.getCell("A11").fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4AB7E7" }, // Blue background
        };

        // Table header
        const headerRow = sheet.addRow(["Rank", "Name", "# Questions Attempted", "# Questions Correct", 'Mark Scored', "% Score"]);
        headerRow.font = { bold: true, size: 12 };
        // headerRow.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "FFB7D6F0" } // Light blue background
        // };
        // Apply background color + borders to header row
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFB7D6F0" } // Light blue (your screenshot color)
            };
        });
        // Loop through students array and add rows
        classPerformanceData.studentDetails.forEach((item, index) => {
            if (index === classPerformanceData.studentDetails.length - 1) {
                let lastRow = sheet.addRow([item.rank, item.studentName, item.questionsAttempted, item.questionsCorrect, item.markScored, `${item.scorePercentage}%`]);
                lastRow.font = { bold: true };
            } else {
                sheet.addRow([item.rank, item.studentName, item.questionsAttempted, item.questionsCorrect, item.markScored, `${item.scorePercentage}%`]);
            }
        });

        sheet.addRow([]);

        let secondHeaderRow = sheet.addRow(["Not Attempted Students"]);
        secondHeaderRow.font = { bold: true, size: 12 };
        // secondHeaderRow.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "FFB7D6F0" } // Light blue background
        // };
        // Apply background color + borders to header row
        secondHeaderRow.eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFB7D6F0" } // Light blue (your screenshot color)
            };
        });
        // Loop through students array and add rows
        classPerformanceData.notAttemptedStudentNameList.forEach((item, index) => {
            sheet.addRow([item]);
        });

        // Generate Excel buffer
        const buffer = await workbook.xlsx.writeBuffer();

        // Trigger download
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download =
            `student_performance_report_${selectedItem.chapters[0].title.split(' ').join('_')}_` + new Date().toISOString() + ".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);


    };

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    expand = (item, index) => {
        let testList = this.state.testList
        testList[index].expand = !testList[index].expand
        this.setState({ testList })
    }

    onClickTab = (index) => {
        this.setState({ activeTabIndex: index, selectedItemIndex: null })
        let tab = this.state.tabs[index]
        this.filter.status = tab.value
        this.filter.page = 1
        this.getTestList(this.filter)
    }

    hideReport = () => {
        this.setState({ showReport: false, selectedReportType: '', showCompletionReport: false, showWrongAnswersReport: false }, () => {
            this.scrollIntoViewForCurrentItem(this.state.selectedItem._id)
        })
    }

    scrollIntoViewForCurrentItem(id) {
        const element = document.getElementById(id);
        // console.log(id, element)
        element.scrollIntoView({ behavior: "instant", block: 'center' })

    }

    onClickBack = () => {
        if (Constants.ELECTRON_BUILD) {
            this.props.history.push(Path.DASHBOARD)
        }
        this.props.back && this.props.back()
    }

    onClickNewTest = () => {
        // this.props.delegate?.showNewTest && this.props.delegate.showNewTest()
        this.setState({ showNewTest: true })
    }

    onClickViewSummary = () => {
        this.setState({ showViewSummary: true })
    }


    hideNewTest = (value) => {
        if (value) {
            this.filter = { status: "ACTIVE" }
            this.getTeacherHomeworkActivities(this.filter)
        }
        this.setState({ showNewTest: false })
    }

    hideAssessmentSummary = () => {

        this.filter = { status: "ACTIVE" }
        this.getTeacherHomeworkActivities(this.filter)

        this.setState({ showViewSummary: false })
    }

    showReport = (type, item, index) => {
        // console.log(item)
        this.setState({ showReport: true, selectedReportType: type, selectedItem: item, selectedItemIndex: index })
    }

    getButtonTitle = (status) => {
        if (status == 'ASSIGNED')
            return "Start"

        if (status == 'COMPLETED')
            // return this.staticText.learnButtonTitle
            return "Completed"



        if (status == 'IN_PROGRESS')
            return "Resume"
    }

    onClickCard(item, index) {

        console.log(item)

        let teacherHomeworkItem = this.teacherHomeworkActivityStatusHash[item._id]

        if (!CommonUtils.isOnline() && this.layoutShared.state.homeworkItem &&
            this.layoutShared.state.homeworkItem.homeworkId &&
            this.layoutShared.state.homeworkItem.status != 'COMPLETED') {
            teacherHomeworkItem = this.teacherHomeworkActivityStatusHash[item.homeworkId]
        }


        console.log(teacherHomeworkItem)

        if (item.autoNext) {
            teacherHomeworkItem.autoNext = item.autoNext
        }

        if (item.selectedSetId) {
            teacherHomeworkItem.selectedSetId = item.selectedSetId
            teacherHomeworkItem.selectedSetTitle = item.selectedSetTitle
        }

        if (item.teacherHomeworkActivityStatus !== 'COMPLETED') {
            this.setState({ showAssessmentFlow: true, teacherHomeworkItem })
        }

        // if (item.teacherHomeworkActivityStatus === 'COMPLETED') {
        //     this.showDiagnosticAssessmentReport(item, index)
        // }
    }




    getTabs = () => {
        return (<div>
            {this.state.tabs.map((tab, index) => (
                <div key={'tab' + index} className={`tab mr-3 ${this.state.activeTabIndex == index ? 'tab-active' : ''}`} onClick={() => this.onClickTab(index)}>
                    <div className='tab-center'>
                        <span>{tab.title}</span>
                    </div>

                    {this.state.activeTabIndex == index ? <div className='active-cirlce'>
                    </div> : ""}
                </div>
            ))}
        </div>)
    }


    getTestCard = (item, index) => {

        return (
            <div className='test-card'>
                <div className='row m-0'>
                    <div className='col border-bottom border-right'>
                        <div className='header-label'>Created: <strong>{item.createdDate}</strong></div>
                    </div>
                    {/* <div className='col border-bottom'>
                        <div className='header-label'>Due: <strong className="pr-2">{item.dueDate}</strong>
                        </div>
                    </div> */}
                </div>

                <div className='p-3'>
                    <div className='row '>
                        <div className='col'>
                            <div className='body-title'>Chapters</div>
                            {item.chapters?.map(chapter => (
                                <div className='body-sub-title pt-2'><strong>{chapter.title}</strong></div>
                            ))}
                            <div className='button-wrapper mt-2 cursor-pointer' onClick={() => this.onClickCard(item, index)}>
                                <div className='start-button'>{this.getButtonTitle(item.teacherHomeworkActivityStatus)}</div>
                            </div>

                        </div>
                        <div className="col text-right">
                            <span>Qs: <strong className="mr-2">{item.questions || 0}</strong></span>
                            <span>Time: {item.time ? <strong className="">{item.time} mins</strong> : "-"}</span>
                        </div>
                    </div>

                    {/* <div className='pt-3 row more-color'>
                        <div className='col my-auto'>
                            {item?.type == "DIAGNOSTIC" ? <span className="type-tag ">Chapter Readiness Test</span> : ""}
                        </div>
                        <div className='col text-right'>
                            {
                                item?.status != "ARCHIVED" ? this.getActions(item, index) : this.getActivateHomework(item)
                            }
                        </div>
                    </div> */}
                </div>

            </div>
        )

    }

    viewQuestions = (item, index) => {


        //let pathname = `${type}${item._id}/${item.chapters[0].title}/${item.class}/${item.createdDateTimestamp}`

        this.setState({ showAllQuestions: true, selectedItem: item, selectedItemIndex: index })

        //let origin = window.location.origin

        //window.open(origin + pathname)

    }

    hideQuestions = () => {
        this.hideReport()
        this.setState({ showAllQuestions: false, showQuestionList: false, questionLoading: false })
    }

    renderStatus = (item, index) => {
        return (<div>
            <div className='completed'>
                <div className='completed-text'>
                    <div className='cursor-pointer' onClick={() => this.onClickCompletionReport(item, index)}>
                        <span>
                            <img className="status-image" src={getImageSource(ImageConstants.CORRECT)} />
                        </span>
                        <span className="float-right">
                            {item.completed}
                        </span>
                    </div>
                </div>
            </div>

            <div className='not-completed mt-3'>
                <div className='not-completed-text'>
                    <div className='cursor-pointer' onClick={() => this.onClickCompletionReport(item, index)}>
                        <span>
                            <img className="status-image" src={getImageSource(ImageConstants.WRONG)} />
                        </span>
                        <span className="float-right">
                            {item.notCompleted}
                        </span>
                    </div>
                </div>
            </div>
        </div>)
    }

    // onClickCompletionReport = (type, item, index) => {


    //     let pathname = `${type}${item._id}/${item.chapters[0].title}/${item.class}/${item.createdDateTimestamp}`

    //     this.setState({ showCompletionReport: false, selectedItem: item, selectedItemIndex: index })

    //     let origin = window.location.origin

    //     window.open(origin + pathname)


    // }

    onClickCompletionReport = (item, index) => {


        //let pathname = `${type}${item._id}/${item.chapters[0].title}/${item.class}/${item.createdDateTimestamp}`

        //console.log(item)

        this.setState({ showCompletionReport: true, selectedItem: item, selectedItemIndex: index })

        // let origin = window.location.origin

        // window.open(origin + pathname)


    }

    onClickWrongAnswersReport = (item, index) => {


        // let pathname = `${type}${homeworkType}/${item._id}/${item.chapters[0].title}/${item.class}/${item.createdDateTimestamp}`

        this.setState({ showWrongAnswersReport: true, selectedItem: item, selectedItemIndex: index })

        // let origin = window.location.origin

        // window.open(origin + pathname)

    }

    hideWrongAnswersReport = () => {
        this.setState({ showWrongAnswersReport: false })
    }

    hideReminderModal = () => {
        this.setState({ showReminderModal: false })
    }

    onOkArchiveModal = () => {
        this.setState({ showArchiveModal: false })
    }

    onCloseArchiveModal = () => {
        this.setState({ showArchiveModal: false })
    }

    onOkDeleteModal = () => {
        this.setState({ showDeletionModal: false })
    }

    onCloseDeleteModal = () => {
        this.setState({ showDeletionModal: false })
    }

    onOkClickerAssignModal = () => {
        this.setState({ showClickerAssignModal: false })
    }

    onCloseClickerAssignModal = () => {
        this.setState({ showClickerAssignModal: false })
    }

    onClickAssignClickerPractice = (item) => {
        console.log(item)
        // this.getClasses()
        this.setState({
            showClickerAssignModal: false, showNewTest: true,
            isClonePractice: true,
            selectedHomework: item
        })
    }


    onOkActiveModal = () => {
        this.setState({ showActiveConfirmationModal: false })
    }

    onCloseActiveModal = () => {
        this.setState({ showActiveConfirmationModal: false })
    }

    toggleLayoutBar() {
        console.log('toggle called')

        // this.setState({hideLayoutSideBar : !this.state.hideLayoutSideBar}, () => {
        this.layoutShared.showHideLayoutBar(!this.layoutShared.state.showLayoutBar)
        if (window.electron && window.electron.ipcRenderer) {
            window.electron.ipcRenderer.send('toggle-fullscreen', { fullscreen: true });
        }

        // this.layoutShared.toggleSidebar(this.state.hideLayoutSideBar)
        // })

    }

    showClickerAssessmentList() {
        this.setState({ showAssessmentFlow: false }, () => {
            // this.toggleLayoutBar()
            this.layoutShared.showHideLayoutBar(!this.layoutShared.state.showLayoutBar)
            if (window.electron && window.electron.ipcRenderer) {
                window.electron.ipcRenderer.send('toggle-fullscreen', { fullscreen: false });
            }
            if (!CommonUtils.isOnline() && navigator.onLine) {

                if (window.AndroidClicker) {
                    CommonApi.getCountryCode({}).then((response) => {
                        let data = response.response
                        console.log(data.length)
                        this.layoutShared.forceOffline(false)
                    }).catch((err) => {
                        this.layoutShared.forceOffline(true, '')
                        this.getTeacherHomeworkActivities()
                        this.setState({ loading: true }, () => {
                            setTimeout(() => {
                                this.setState({ loading: false })
                            }, 200)
                        })
                        // alert("Error while fetching country code. Please try again later.");
                        // console.log(err)
                    })
                } else {
                    this.layoutShared.forceOffline(false)
                }


            } else {
                this.getTeacherHomeworkActivities()
            }
        })
    }



    onChangeType = (type) => {
        this.setState({ notificationType: type })
    }

    renderReminderModal = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideReminderModal} size={'lg'}>
                <ModalBody >
                    <ReminderModel message={this.state.reminderMessage} notCompleted={this.state.notCompleted} homeworkId={this.state.reminderHomeworkId} notificationCount={this.state.notificationCount} notificationDate={this.state.notificationDate} back={this.hideReminderModal} />
                </ModalBody>
            </Modal>
        )
    }

    renderNotificationModal = () => {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideNotification} size={'lg'}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideNotification} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>

                    <div className="header-text text-center pt-4">
                        <span>SHARE THE INVITE WITH STUDENTS</span>
                    </div>
                    <NotificationModel type={this.state.notificationType} assessment={this.state.selectedItem} onChangeType={this.onChangeType} onOk={this.onSentNotification} />
                </ModalBody>
            </Modal>
        )
    }

    onClickReminderModal(item) {
        let [d, m, y] = item.dueDate.split("/")

        if (m.length == 1) {
            m = `0${m}`
        }
        if (d.length == 1) {
            d = `0${d}`
        }
        let dateString = `${y}-${m}-${d}`
        let chapters = item?.chapters.map(item => item.title)
        let chapter = chapters.join(", ")
        let date = moment(dateString).format("Do MMM")
        let message = `Assessment assigned to you from chapter ${chapter || ""} still pending. Please complete it soon before due date i.e ${date}.`
        let notificationCount = item.notificationCount
        let notificationDate = item.lastNotificationSentDate
        this.setState({
            reminderHomeworkId: item._id,
            reminderMessage: message,
            showReminderModal: true,
            notificationCount,
            notificationDate,
            notCompleted: item?.notCompleted
        })
    }

    onClickDelete = (item) => {
        let payload = { testId: item._id, status: "ARCHIVED" }
        TestApi.updateTest(payload)
            .then(response => {
                this.showToaster('Info', 'Deleted Successfully')
                this.setState({ showDeletionModal: false }, () => {
                    this.getTestList(this.filter)
                })

            }).catch(err => {
            })
    }

    onClickActivate = (item, dueDate) => {
        let payload = {
            testId: item._id, status: "ACTIVE"
        }

        if (dueDate) {
            payload.dueDate = dueDate
        }


        TestApi.updateTest(payload)
            .then(response => {

                this.setState({ showActiveConfirmationModal: false }, () => {
                    this.getTestList(this.filter)
                })

            }).catch(err => {
            })
    }


    onCLickNotitification(item, type) {
        this.setState({ notificationType: type, selectedItem: item, showNotification: true })
    }

    hideNotification = () => {
        this.setState({ showNotification: false })
    }

    showRewardToaster = (item) => {
        if (item.point) {
            // this.showToaster('info', `🎁 YAY! You just earned ${item.point} reward points for assigning the Assessment to ${item?.totalUsers} for ${item?.class}${item.section ? " " + item.section : ""}`)
        }
    }

    onSentNotification = () => {
        this.hideNotification()
        this.showToaster('info', "Message shared successfully")
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 8000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }

    onClickUserList(index, groupIndex, item) {
        this.setState({ userListIndex: index, userListGroupIndex: groupIndex, selectedItem: item, showUsersList: true })
    }



    onHideUserList() {
        this.setState({ userList: [], userListIndex: "", userListGroupIndex: "", showUsersList: false })

    }

    onClickQuestionList(item, index) {
        this.setState({
            selectedQuestionList: item,
            contents: [],
            questionLoadingIndex: index,
            questionLoading: true,
            showQuestionList: true,
            selectedItem: item
        })
    }



    showSuccessModal = (item) => {
        let selectedSection = {}
        item.sectionId.forEach(sectionId =>
            selectedSection[sectionId] = item.section[sectionId]
        )

        item.section = selectedSection
        this.setState({ showSuccess: true, selectedItem: item })
    }

    onInviteMoreStudent = () => {
        this.setState({ showSuccess: false, notificationType: "WHATSAPP", showNotification: true })
    }

    closeSuccess = () => {
        this.setState({ showSuccess: false })
    }

    onClickTestClicker(item) {

        if (CommonUtils.isOnline()) {
            this.setState({ showTestClickerScreen: true, selectedItem: item })
        } else if (!CommonUtils.isOnline()) {
            console.log('offline resume')

            dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'homeworkId', item._id).then(teacherHomeworkActivityData => {
                let teacherHomeworkActivity = teacherHomeworkActivityData[0]

                let userIds = teacherHomeworkActivity.userIdsList
                // To Add Teacher UserId
                userIds.push(teacherHomeworkActivity.userId)


                dbHelper.getAllByIds(Constants.CLICKER_USERS_STORE, teacherHomeworkActivity.userIdsList).then(clickerUserList => {
                    clickerUserList = clickerUserList.sort((a, b) => a.studentNumber - b.studentNumber)

                    this.setState({ showTestClickerScreen: true, selectedItem: item, studentList: clickerUserList })

                })
            }).catch(err => {
                console.log(err)
            })
        }
    }

    hideTestClickerScreen() {
        this.setState({ showTestClickerScreen: false, selectedItem: '' })
    }

    downloadAssessmentResultExcel = (item, index) => {
        console.log('item', item)
        this.setState({ selectedItem: item, selectedItemIndex: index })

        let payload = {}

        if (payload.page) payload.page = 1
        if (payload.page) payload.limit = this.limit

        if (item && item._id) {
            payload.testId = item._id
        }

        TestApi.getTestResultReport(payload)
            .then(response => {

                console.log("response", response)

                let levels = this.state.levels
                let noviceStudents = response?.noviceStudents || []
                let proficientStudents = response?.proficientStudents || []
                let advancedStudents = response?.advancedStudents || []
                let notCompletedStudents = response?.notCompletedStudents || []

                levels[0].students = noviceStudents
                levels[1].students = proficientStudents
                levels[2].students = advancedStudents

                this.setState({ levels, notCompletedStudents, isLoading: false }, () => {
                    this.onClickAssessmentResultExport()
                })

            }).catch(err => {
                console.log(err)
            })
    }

    onClickAssessmentResultExport = () => {

        if (this.state.exporting) return

        this.setState({ exporting: true })
        console.log("Export")


        if (this.state.levels && this.state.levels.length) {

            let homeworkCompletedStudentArray = this.state.levels
            let item = this.state.selectedItem

            let titleClassSection = '';
            if (item && item.class) {
                titleClassSection = item.class;
                if (item.section) titleClassSection += ` ${item.section}`;
            }

            const workbook = new ExcelJS.Workbook();
            const sheet = workbook.addWorksheet("Evaluation Report");

            sheet.columns = [
                { width: 35 },
                { width: 15 },
                { width: 15 },
                { width: 15 }
            ];

            const borderStyle = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };

            // Row 1: Title
            let schoolName = this.state.userInfo?.schoolInfo?.name || '';
            const topRowText = `${schoolName ? schoolName + ' - ' : ''}${titleClassSection} : ${item?.title || item?.testName || 'Baseline Assessment'}`;
            const row1 = sheet.addRow([topRowText, topRowText, topRowText, topRowText]);
            sheet.mergeCells("A1:D1");
            row1.eachCell((cell) => {
                cell.font = { size: 14 };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD9D9D9" } };
                cell.border = borderStyle;
            });

            // Row 2: Chapter Name
            const chaptersText = (item?.chapters || []).map(c => c.title || c.name).join(', ');
            const row2 = sheet.addRow([chaptersText, chaptersText, chaptersText, chaptersText]);
            sheet.mergeCells("A2:D2");
            row2.eachCell((cell) => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD9D9D9" } };
                cell.border = borderStyle;
            });

            // Row 3: Header Row
            const headerRow = sheet.addRow(["Student", "Mark Scored", "Total Marks", "% Score"]);
            headerRow.eachCell((cell) => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD9E1F2" } };
                cell.border = borderStyle;
            });

            // Loop categories
            for (let i = 0; i < homeworkCompletedStudentArray.length; i++) {
                let cat = homeworkCompletedStudentArray[i];

                if (cat["type"]) {
                    let catLabel = cat["type"];
                    if (catLabel === "NOVICE") catLabel = "NOVICE  (-<50%)";
                    if (catLabel === "PROFICIENT") catLabel = "PROFICIENT (51% - 80%)";
                    if (catLabel === "ADVANCED" || catLabel === "ADVANCE") catLabel = "ADVANCE  (80%+)";

                    // Category header
                    let catRow = sheet.addRow([catLabel, catLabel, catLabel, catLabel]);
                    sheet.mergeCells(`A${catRow.number}:D${catRow.number}`);
                    catRow.eachCell((cell) => {
                        cell.font = { bold: true };
                        cell.alignment = { horizontal: "center", vertical: "middle" };
                        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF5B9BD5" } };
                        cell.border = borderStyle;
                    });

                    if (cat.students && cat.students.length > 0) {
                        let sortedStudents = [...cat.students].sort((a, b) => {
                            let percentA = (a.marks / a.totalMark) || 0;
                            let percentB = (b.marks / b.totalMark) || 0;
                            return percentA - percentB;
                        });
                        for (let j = 0; j < sortedStudents.length; j++) {
                            let student = sortedStudents[j];

                            let row = sheet.addRow([student.name, student.marks, student.totalMark]);
                            // Add % score formula
                            let rowNum = row.number;
                            let percentCell = row.getCell(4);
                            percentCell.value = { formula: `B${rowNum}/C${rowNum}` };
                            percentCell.numFmt = '0%';

                            row.eachCell((cell) => {
                                cell.border = borderStyle;
                            });
                        }
                    } else {
                        let emptyRow = sheet.addRow(["No Students in this Type", "", "", ""]);
                        emptyRow.eachCell((cell) => cell.border = borderStyle);
                    }
                }
            }

            workbook.xlsx.writeBuffer().then(buffer => {
                const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const url = window.URL.createObjectURL(blob);

                let hiddenElement = document.createElement('a');
                hiddenElement.href = url;
                hiddenElement.target = '_blank';
                hiddenElement.download = 'Assessment_Evaluation_Report.xlsx';
                hiddenElement.click();

                window.URL.revokeObjectURL(url);

                this.setState({ exporting: false })
            }).catch(err => {
                console.error(err);
                this.setState({ exporting: false })
            });

        } else {
            this.setState({ exporting: false })
        }

    }

    downloadCompletionExcelReport(item, index) {
        console.log(item)
        this.setState({ selectedItem: item, selectedItemIndex: index })
        let payload = {}
        if (payload.page) payload.page = 1
        if (payload.page) payload.limit = this.limit

        if (item) {
            payload.testId = item._id
        }

        TestApi.getTestCompletionReport(payload)
            .then(response => {

                console.log("response", response)
                this.setState({
                    completedStudents: response.completedStudents,
                    inProgressStudents: response.inProgressStudents,
                    notCompletedStudents: response.notCompletedStudents, isLoading: false
                }, () => {
                    this.onClickCompletionReportExport()
                })

            }).catch(err => {
            })
    }

    onClickCompletionReportExport = async () => {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Completion Report");

        // Header
        sheet.mergeCells("A1:C1");
        sheet.getCell("A1").value = "Completion Report";
        sheet.getCell("A1").font = { bold: true, size: 14 };
        sheet.getCell("A1").alignment = { horizontal: "center" };
        sheet.getCell("A1").fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4AB7E7" }, // Blue background
        };


        // Table header
        const headerRow = sheet.addRow(["Completed", "Inprogress", "Not Completed"]);
        headerRow.font = { bold: true, size: 12 };
        // headerRow.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "FFB7D6F0" } // Light blue background
        // };
        // Apply background color + borders to header row
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFB7D6F0" } // Light blue (your screenshot color)
            };
        });

        // Find max length between both arrays
        const maxLength = Math.max(this.state.completedStudents.length, this.state.inProgressStudents.length, this.state.notCompletedStudents.length);

        // Fill rows with student names
        for (let i = 0; i < maxLength; i++) {
            sheet.addRow([
                (this.state.completedStudents[i] && this.state.completedStudents[i].name) || "", // Completed name if exists
                (this.state.inProgressStudents[i] && this.state.inProgressStudents[i].name) || "", // Not completed name if exists
                (this.state.notCompletedStudents[i] && this.state.notCompletedStudents[i].name) || ""
            ]);
        }

        // Generate Excel buffer
        const buffer = await workbook.xlsx.writeBuffer();

        // Trigger download
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download =
            `completion_report_${this.state.selectedItem.chapters[0].title.split(' ').join('_')}_` + new Date().toISOString() + ".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    }

    downloadLearningGapExcelReport(item, index) {
        this.setState({ selectedItem: item, selectedItemIndex: index })

        let chapterKeys = item.chapters.map(item => item.key)
        let payload = {}
        if (item && item._id) {
            payload.homeworkId = item._id
            payload.type = item.type
            payload.chapterKeys = chapterKeys
        }

        this.setState({ isLoading: true })

        TestApi.getTestEloReport(payload)
            .then(response => {
                console.log(response)
                let skillBaseReport = response.skillBaseReport || {}
                let localSkillList = this.skillList
                let result = []
                // for (let i = 0; i < localSkillList.length; i++) {
                //     let skill = localSkillList[i]
                //     let detail = skillBaseReport[skill.type.toLowerCase()]
                //     if (!detail) continue
                //     skill.mastered = detail.correct || 0
                //     skill.correctUsers = detail.correctUsers || []
                //     skill.incorrectUsers = detail.incorrectUsers || []
                //     skill.needImprovement = detail.incorrect
                //     let total = detail.correct + detail.incorrect
                //     skill.masteredPercentage = this.calculatePercentage(detail.correct, total)
                //     skill.needImprovementPercentage = 100 - skill.masteredPercentage
                //     result.push(skill)
                // }

                this.setState({
                    skillWiseReport: result, eloReport: response.conceptBaseReport,
                    chapterBaseReport: response.chapterBaseReport, totalUsers: response.totalUsers, isLoading: false
                }, () => {
                    this.onClickLearningGapReportExport()
                })

            }).catch(err => {

                this.setState({ isLoading: false })
            })
    }

    onClickLearningGapReportExport = () => {

        if (this.state.exporting) return

        this.setState({ exporting: true })
        console.log("Export")

        let eloList = this.state.eloReport

        let chapterBaseReport = this.state.chapterBaseReport



        if (chapterBaseReport && chapterBaseReport.length > 0) {

            let homeworkCompletedStudentArray = chapterBaseReport

            console.log(homeworkCompletedStudentArray)

            let csvBuild = []
            for (let i = 0; i < homeworkCompletedStudentArray.length; i++) {
                let item = homeworkCompletedStudentArray[i]

                let obj = {
                }
                if (item["chapterTitle"]) {

                    if (item['chapterTitle']) {
                        obj['Chapter Name'] = item['chapterTitle']
                    }

                    // if (item['conceptName']) {
                    //     obj['Understood'] = "Understood"
                    // }

                    // if (item['conceptName']) {
                    //     obj['Not Understood'] = 'Not Understood'
                    // }

                    // if (item['conceptName']) {
                    //     obj['Not Attempted'] = 'Not Attempted'
                    // }

                    csvBuild.push(obj)

                    let concepts = Object.values(item.concepts)

                    // console.log(concepts)

                    if (concepts.length) {
                        concepts.map((item, cindex) => {
                            let eloObject = {}

                            let elo = item
                            if (elo.skill == "modelling") elo.skill = "modeling"
                            let skills = elo.skill
                            for (let index = 0; index < this.orderedSkills.length; index++) {
                                let key = this.orderedSkills[index]
                                let skillDetails = skills[key]

                                if (!skillDetails) continue

                                if (skillDetails && skillDetails.length) {
                                    // arr.push(
                                    //     <tr className="mt-4">
                                    //         <td className="skill-title pl-5" colSpan="4">
                                    //             <span>
                                    //                 <img className="skill-img" src={getImageSource(ImageConstants[key.toUpperCase()])} /><b className="pl-4">{key.toUpperCase()}</b>
                                    //             </span>
                                    //         </td>
                                    //     </tr>
                                    // )


                                    for (let i = 0; i < skillDetails.length; i++) {
                                        let item = skillDetails[i]
                                        let notAttempted = this.state.totalUsers - ((item.incorrect || 0) + (item.correct || 0))
                                        eloObject['Concept Name'] = item.title
                                        eloObject['Understood'] = item.correct
                                        eloObject['Not Understood'] = item.incorrect
                                        eloObject['Not Attempted'] = notAttempted
                                        csvBuild.push(eloObject)
                                        eloObject = {}
                                    }
                                }
                            }
                        })
                    }
                }
            }
            let json2csvParser = new Parser();
            let csv = json2csvParser.parse(csvBuild);

            // console.log(csv);

            let hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = 'learning_gap_report_' + (new Date).toISOString() + '.csv';
            hiddenElement.click();

            this.setState({ exporting: false })

        } else {
            this.setState({ exporting: false })
        }
    }

    onClickDownloadPdf = (type, item, index) => {

        this.setState({ selectedReportType: type, selectedItem: item, selectedIndex: index, isPdfLoading: true })

        if (type === 'MOST_WRONG_REPORT') {
            this.getTestWrongAnswer(item, type)
        }

        if (type === "RECOMMANDATION_REPORT") {
            this.getTestWrongAnswer(item, type)
        }

        if (type === 'CLASS_PERFORMANCE_REPORT') {
            this.getClassPerformanceReport(item, type)
        }

        if (type === 'SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT') {
            this.getSchoolworkOverallClassPerformanceReport(item, type)
        }

        if (type === 'STUDENT_EVALUATION_REPORT') {
            this.getStudentEvaluationReport(item, type)
        }

    }

    getStudentEvaluationReport(selectedItem) {
        let chapterName = Array.isArray(selectedItem.chapters) && selectedItem.chapters.length > 0
            ? (typeof selectedItem.chapters[0] === 'object' ? (selectedItem.chapters[0].title || selectedItem.chapters[0].name || selectedItem.chapters[0].chapterName || '') : selectedItem.chapters[0])
            : (selectedItem.chapterTitle || selectedItem.chapterName || selectedItem.chapter || selectedItem.title || '');

        TestApi.getStudentEvaluationReportPdf({ testId: selectedItem._id, chapterName: chapterName }).then(response => {
            this.downloadPDF(response.link, "Assessment_Evaluation_Report");
            this.setState({ isPdfLoading: false });
        }).catch(err => {
            console.log(err);
            this.setState({ isPdfLoading: false });
        })
    }

    getSchoolworkOverallClassPerformanceReport(selectedItem) {

        let payload = {
            homeworkId: selectedItem._id,
            classText: selectedItem.class,
            board: selectedItem.board,
            type: selectedItem.type,
            sectionId: selectedItem.sectionId,
            masterDataId: selectedItem.masterDataId,
            duration: selectedItem.approximateTime,
            chapterKey: selectedItem.chapterKey,
            chapterTitle: selectedItem.chapter
        }

        // this.setState({ isLoading: true })

        HomeworkForClickerPracticeApi.getSchoolworkOverallClassPerformanceReport(payload).then(res => {
            // console.log(res)
            this.setState({ isPdfLoading: false })

            this.downloadPDF(res.link, "Class_Performance_Report")

        }).catch(err => {
            console.log(err)
        })
    }

    getClassPerformanceReport(selectedItem) {

        let payload = {
            homeworkId: selectedItem._id,
            classText: selectedItem.class,
            board: selectedItem.board,
            type: selectedItem.type,
            sectionId: selectedItem.sectionId,
            masterDataId: selectedItem.masterDataId,
            duration: selectedItem.approximateTime,
            chapterKey: selectedItem.chapterKey
        }

        // this.setState({ isLoading: true })

        HomeworkForClickerPracticeApi.getClassPerformanceReport(payload).then(res => {
            console.log(res)
            // this.setState({ ...res, isLoading: false })
            this.setState({ isPdfLoading: false })
            this.downloadPDF(res.link, 'Students_Performance')

        }).catch(err => {
            console.log(err)
        })
    }

    getEloReport(selectedItem, selectedReportType) {
        let payload = {}
        let chapterKeys = selectedItem.chapters.map(item => item.key)
        if (selectedItem) {
            payload.homeworkId = selectedItem._id
            payload.type = selectedItem.type
            payload.chapterKeys = chapterKeys
        }

        // this.setState({ isLoading: true })

        TestApi.getTestEloReport(payload)
            .then(response => {

                console.log(response)

                let skillBaseReport = response.skillBaseReport || {}
                let localSkillList = this.skillList
                let result = []
                // for (let i = 0; i < localSkillList.length; i++) {
                //     let skill = localSkillList[i]
                //     let detail = skillBaseReport[skill.type.toLowerCase()]
                //     if (!detail) continue
                //     skill.mastered = detail.correct || 0
                //     skill.correctUsers = detail.correctUsers || []
                //     skill.incorrectUsers = detail.incorrectUsers || []
                //     skill.needImprovement = detail.incorrect
                //     let total = detail.correct + detail.incorrect
                //     skill.masteredPercentage = this.calculatePercentage(detail.correct, total)
                //     skill.needImprovementPercentage = 100 - skill.masteredPercentage
                //     result.push(skill)
                // }

                let conceptWiseReport = response.conceptBaseReport

                let conceptWiseTopFiveNotClearedElo = []

                let conceptNames = []

                for (let i = 0; i < conceptWiseReport.length; i++) {
                    let concept = conceptWiseReport[i]
                    let allSkills = {}
                    let eloLimit = 0

                    for (let j = 0; j < localSkillList.length; j++) {
                        let skill = localSkillList[j]
                        let detail = concept.skill[skill.type.toLowerCase()]
                        if (!detail) continue

                        let notClearedEloList = []

                        for (let k = 0; k < detail.length; k++) {
                            let elo = detail[k]
                            if (elo.incorrect) {
                                if (eloLimit === 5) continue
                                eloLimit += 1
                                notClearedEloList.push(elo)
                            }
                        }

                        if (!allSkills[skill.type.toLowerCase()]) {
                            allSkills[skill.type.toLowerCase()] = [...notClearedEloList]
                        } else {
                            allSkills[skill.type.toLowerCase()].push(notClearedEloList)
                        }
                    }
                    conceptNames.push(concept.conceptName)
                    conceptWiseTopFiveNotClearedElo.push({ conceptName: concept.conceptName, skill: allSkills })

                }


                let conceptKeysList = response.conceptKeysList

                let conceptKeys = []

                conceptKeysList.forEach(conceptKey => {
                    let obj = {
                        conceptKey: conceptKey
                    }

                    conceptKeys.push(obj)
                })

                // let homeworkAssignPayload = this.state.homeworkAssignPayload
                // homeworkAssignPayload.conceptKey = conceptKeys

                this.setState({
                    skillWiseReport: result,
                    eloReport: response.topFiveNotClearedEloAcrossConcept,
                    totalUsers: response.totalUsers, isLoading: false
                }, () => {
                    setTimeout(() => {
                        this.generatePdf(response.topFiveNotClearedEloAcrossConcept, conceptNames, selectedItem)
                    }, 1000)

                })

            }).catch(err => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    calculatePercentage(scored = 0, total = 0) {

        if (scored == 0 || total == 0) return 0

        return Math.round((scored / total) * 100)
    }


    generatePdf(conceptWiseTopFiveNotClearedElo, conceptNames, selectedItem) {
        // console.log(conceptWiseTopFiveNotClearedElo)


        let notClearedEloIds = [], eloNotClearedStudentPercentageHashByEloId = {}

        conceptWiseTopFiveNotClearedElo.forEach(elo => {
            // if (elo.skill == "modelling") elo.skill = "modeling"
            // let skills = elo.skill
            // for (let index = 0; index < this.orderedSkills.length; index++) {
            //     let key = this.orderedSkills[index]
            //     let skillDetails = skills[key]

            //     if (!skillDetails) continue

            //     if (skillDetails && skillDetails.length) {

            //         skillDetails.map(item => {
            notClearedEloIds.push(elo.eloId)
            eloNotClearedStudentPercentageHashByEloId[elo.eloId] = `${this.calculatePercentage(elo.incorrect, this.state.totalUsers) || 0}%`
            //         })

            //     }

            // }
        })

        // console.log(notClearedEloIds)



        if (!this.state.contentIds.length && !notClearedEloIds.length) {
            return;
        }

        let payload = {
            contentIds: this.state.contentIds,
            class: selectedItem.class,
            section: selectedItem.section ? selectedItem.section : "",
            chapterTitle: selectedItem.chapter,
            conceptNames: conceptNames,
            notClearedEloIds,
            topWrongPercentage: this.state.topWrongPercentage,
            eloNotClearedStudentPercentageHashByEloId
        }

        SchoolApi.generatePdf(payload).then(response => {
            console.log(response)
            this.setState({ isPdfLoading: false })

            this.downloadPDF(response.data.webLink, "Remedial_Report")

        }).catch(err => {
            console.log(err)
        })

    }


    getChapterNames(chapters) {
        let arr = []
        for (let i = 0; i < chapters.length; i++) {
            arr.push(chapters[i].title)
        }
        return arr.join(", ")
    }




    getTestWrongAnswer(selectedItem, selectedReportType) {

        let payload = {}

        if (selectedItem) {
            payload.testId = selectedItem._id
        }
        if (this.props.usersId) {
            payload.usersId = this.props.usersId
        }

        payload.chapterTitle = selectedItem.chapter ? selectedItem.chapter : ""
        payload.isPdfGeneration = true

        // this.setState({ isLoading: true })

        TestApi.getTestWrongAnswersReport(payload)
            .then(response => {

                // console.log("response", response)
                let wrongAnswersHash = {}

                let result = response.result.sort((x, y) => (x.percentage > y.percentage ? -1 : 1))

                // console.log(result)


                let filterQuestions = []

                let questionsArray1 = [], users1 = [], questionsArray2 = [], users2 = [],
                    questionsArray3 = [], users3 = [], questionsArray4 = [], users4 = []

                for (let i = 0; i < result.length; i++) {

                    let data = result[i]

                    if (data.percentage < 25) {

                        result[i].filterPercentage = 25
                        result[i].filterRangeText = "Less than 25%"

                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray1.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users1.push(...result[i].users)

                        if (users1.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users1.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray1
                        result[i].allUsers = uniqueAllUsers

                    } else if (data.percentage >= 25 && data.percentage <= 50) {

                        result[i].filterPercentage = 50
                        result[i].filterRangeText = "25 - 50%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray2.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users2.push(...result[i].users)

                        if (users2.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users2.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray2
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 50 && data.percentage <= 75) {

                        result[i].filterPercentage = 75
                        result[i].filterRangeText = "51 - 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray3.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users3.push(...result[i].users)

                        if (users3.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users3.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray3
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 75) {

                        result[i].filterPercentage = 100
                        result[i].filterRangeText = "Greater than 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray4.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users4.push(...result[i].users)

                        if (users4.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users4.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray4
                        result[i].allUsers = uniqueAllUsers
                    } else {
                        result = []
                    }

                    console.log(result[i])
                    if (!wrongAnswersHash[`${result[i].filterPercentage}`]) {
                        wrongAnswersHash[`${result[i].filterPercentage}`] = [result[i]]
                    }

                }



                const uniqueIds = [];

                const unique = result.filter(element => {
                    const isDuplicate = uniqueIds.includes(element.filterPercentage);

                    if (!isDuplicate) {
                        uniqueIds.push(element.filterPercentage);

                        return true;
                    }
                    return false;
                });






                let filterHash = {}
                Object.keys(wrongAnswersHash).forEach(ele => filterHash[ele] = ele)

                let topQuestions = []

                unique.forEach(item => {
                    topQuestions.push(...item.allQuestionsArray)
                })

                let topFiveWrongAnsweredQuestions = topQuestions.slice(0, 5)

                console.log(topFiveWrongAnsweredQuestions)

                let contentIds = []

                topFiveWrongAnsweredQuestions.forEach(question => contentIds.push(question._id.toString()))

                let topWrongPercentage = unique && unique.length ? unique[0].percentage : 0

                this.setState({
                    wrongAnswers: unique, wrongAnswersHash, wrongAnswersOfallUsers: unique,
                    basePath: response.basePath, availabelFiltersHash: filterHash,
                    topFiveWrongAnsweredQuestions,
                    contentIds,
                    topWrongPercentage, pdfLink: response.link
                })

                if (selectedReportType === 'MOST_WRONG_REPORT') {
                    this.setState({ isPdfLoading: false })
                    this.downloadPDF(response.link, "Most_Wrong_Questions")
                } else {
                    this.getEloReport(selectedItem, selectedReportType)
                }
            }).catch(err => {
            })
    }



    downloadPDF(pdfLink, title) {
        const link = document.createElement("a");
        link.href = pdfLink
        // link.target = "_blank";
        link.download = `${title}.pdf`; // name for downloaded file
        link.click();
        this.setState({ selectedReportType: "", selectedItem: '', selectedIndex: "" })
    }

    handleCopy = (id) => {
        navigator.clipboard.writeText(id)
            .then(() => {
                // console.log("Copied:", id);
                this.setState({ copiedId: id });
                ReactTooltip.hide();

                setTimeout(() => {
                    this.setState({ copiedId: null });
                }, 2000);
            })
            .catch(err => console.error("Copy failed:", err));
    };


    getReportList = (item, index) => {

        // console.log(item)
        // return (
        //     <div>
        //         <div className='row'>
        //             <div className='col-7' onClick={() => this.showDiagnosticAssessmentReport(item, index)}>
        //                 <div className='report-wrapper'>
        //                     <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
        //                     <span className={`${this.state.activeTabIndex != 0 ? "blue" : "blue"}`}>Maths Diagnostic Assessment Report</span>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // )

        return (
            <div onMouseEnter={ReactTooltip.rebuild} >

                <div className='row flex-nowrap'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.onClickCompletionReport(item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.EXAM_PAD_ICON)} />
                            {/* <img className='report-icon' src={getImageSource(this.state.activeTabIndex != 0 ? ImageConstants.COMPLETION_REPORT_ACTIVE : ImageConstants.COMPLETION_REPORT)} /> */}
                            <span className={`${this.state.activeTabIndex != 0 ? "blue" : "blue"}`}>Completion Report</span>
                        </div>
                    </div>

                    {
                        item.completed ?
                            <div className='col-5 download-icon-wrapper cursor-pointer' onClick={() => this.downloadCompletionExcelReport(item, index)}>
                                <img data-tip={"Export to Excel"} className='report-icon cursor-pointer' src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} />
                            </div>
                            :
                            <></>
                    }


                    {/* <div className='col-5 download-icon-wrapper'>
                        <img className='report-icon' src={getImageSource(this.state.activeTabIndex != 0 ? ImageConstants.DOWNLOAD_ACTIVE : ImageConstants.DOWNLOAD_ICON)} />
                    </div> */}
                </div>
                <div className='row flex-nowrap' >
                    <div className='col-7 px-0' onClick={() => this.showTestResultsReport(item, index)}>
                        <div className='report-wrapper'>
                            <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                            {/* <img className='report-icon' src={getImageSource(this.state.activeTabIndex != 0 ? ImageConstants.TEST_RESULTS_ACTIVE : ImageConstants.TEST_RESULTS_INACTIVE)} /> */}
                            <span className={`${this.state.activeTabIndex != 0 ? "blue" : "blue"}`}>Evaluation Report</span>
                        </div>
                    </div>

                    {/* <div className='col-5 download-icon-wrapper'>
                        <img className='report-icon' src={getImageSource(this.state.activeTabIndex != 0 ? ImageConstants.DOWNLOAD_ACTIVE : ImageConstants.DOWNLOAD_ICON)} />
                    </div> */}
                    {
                        item.completed ?
                            <div className='col-5 download-icon-wrapper'>
                                <img data-tip={"Export to Excel"} className='report-icon cursor-pointer' onClick={() => this.downloadAssessmentResultExcel(item, index)} src={getImageSource(this.state.activeTabIndex != 0 ? ImageConstants.EXPORT_TO_EXCEL : ImageConstants.EXPORT_TO_EXCEL)} />
                                {
                                    this.state.isPdfLoading && this.state.selectedIndex === index &&
                                        this.state.selectedReportType === 'STUDENT_EVALUATION_REPORT' ? <FontAwesomeIcon size="2x" icon={faSpinner} spin /> :
                                        <img className='green-download-icon cursor-pointer ml-5'
                                            data-tip="Download Report" onClick={() => this.onClickDownloadPdf("STUDENT_EVALUATION_REPORT", item, index)}
                                            src={getImageSource(ImageConstants.PDF_DOWNLOAD_ICON)} />
                                }
                            </div>
                            :
                            <></>
                    }
                </div>



                <div className='row flex-nowrap'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.onClickWrongAnswersReport(item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.WRONG_QUESTIONS)} />
                            {/* <img className='report-icon' src={getImageSource(this.state.activeTabIndex != 0 ? ImageConstants.MOST_WRONGLY_ANSWERED_ACTIVE : ImageConstants.MOST_WRONGLY_ANSWERED)} /> */}
                            <span className={`${this.state.activeTabIndex != 0 ? "blue" : "blue"}`}>Most Wrong Questions</span>
                        </div>
                    </div>

                    {
                        item.completed ?
                            <div className='col-5 download-icon-wrapper d-flex align-items-center'
                            >
                                <img className='report-icon' />

                                {
                                    this.state.isPdfLoading && this.state.selectedIndex === index && this.state.selectedReportType === 'MOST_WRONG_REPORT' ? <FontAwesomeIcon size="2x" icon={faSpinner} spin /> :
                                        <img className='green-download-icon cursor-pointer ml-2'
                                            data-tip="Download Report" onClick={() => this.onClickDownloadPdf("MOST_WRONG_REPORT", item, index)}
                                            src={getImageSource(ImageConstants.PDF_DOWNLOAD_ICON)} />
                                }

                            </div>
                            :
                            <></>
                    }
                </div>

                <div className='row flex-nowrap'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.viewQuestions(item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.ALL_QUESTIONS)} />
                            {/* <img className='report-icon' src={getImageSource(this.state.activeTabIndex != 0 ? ImageConstants.MOST_WRONGLY_ANSWERED_ACTIVE : ImageConstants.MOST_WRONGLY_ANSWERED)} /> */}
                            <span className={`${this.state.activeTabIndex != 0 ? "blue" : "blue"}`}>All Questions</span>
                        </div>
                    </div>

                    {/* <div className='col-5 download-icon-wrapper'>
                        <img className='report-icon' src={getImageSource(this.state.activeTabIndex != 0 ? ImageConstants.DOWNLOAD_ACTIVE : ImageConstants.DOWNLOAD_ICON)} />
                    </div> */}
                </div>

                <div className='row flex-nowrap'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.showReport("ELO_LEVEL_REPORT", item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.BULB_BLUE)} />
                            <span className={`${this.state.activeTabIndex != 0 ? "blue" : "blue"}`}>Learning Gap Report</span>
                        </div>
                    </div>

                    {/* <div className='col-5 download-icon-wrapper cursor-pointer' onClick={() => this.showDownloadReport(item, "ELO_LEVEL_REPORT")}>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div> */}
                    {
                        item.completed ?
                            <div className='col-5 download-icon-wrapper cursor-pointer' onClick={() => this.downloadLearningGapExcelReport(item, index)}>
                                <img data-tip={"Export to Excel"} className='report-icon cursor-pointer' src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} />
                            </div>
                            :
                            <></>
                    }
                </div>
                <div className='row flex-nowrap'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.showReport("RECOMMANDATION_REPORT", item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.BULB_BLUE)} />
                            <span className={`${this.state.activeTabIndex != 0 ? "blue" : "blue"}`}>Remedial Report</span>
                        </div>
                    </div>
                    {
                        item.completed ?
                            <div className='col-5 download-icon-wrapper d-flex align-items-center'
                            >
                                <img className='report-icon' />

                                {
                                    this.state.isPdfLoading && this.state.selectedIndex === index &&
                                        this.state.selectedReportType === 'RECOMMANDATION_REPORT' ? <FontAwesomeIcon size="2x" icon={faSpinner} spin /> :
                                        <img className='green-download-icon cursor-pointer ml-2'
                                            data-tip="Download Report" onClick={() => this.onClickDownloadPdf("RECOMMANDATION_REPORT", item, index)}
                                            src={getImageSource(ImageConstants.PDF_DOWNLOAD_ICON)} />
                                }


                            </div>
                            :
                            <></>
                    }
                </div>
                {/* <div className='row flex-nowrap'>
                    <div className='col-7 px-0' onClick={() => this.getPerformanceReport(item, index)}>
                        <div className='report-wrapper'>
                            <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                            <span className={`${this.state.activeTabIndex != 0 ? "blue" : "blue"}`}>Standard Vs Competency Report</span>
                        </div>
                    </div>
                </div> */}

                <div className='row flex-nowrap align-items-center'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.showReport("CLASS_PERFORMANCE_REPORT", item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                            <span className={`${item.completed ? "blue" : ""}`}>{`Students Performance Report`}</span>
                        </div>
                    </div>
                    {
                        item.completed ?
                            <div className='col-5 download-icon-wrapper'
                            >
                                <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} data-tip={"Export to Excel"}
                                    onClick={() => this.downloadClassPerformanceExcelReport("CLASS_PERFORMANCE_REPORT", item, index)} />

                                {
                                    this.state.isPdfLoading && this.state.selectedIndex === index &&
                                        this.state.selectedReportType === 'CLASS_PERFORMANCE_REPORT' ? <FontAwesomeIcon size="2x" icon={faSpinner} spin /> :
                                        <img className='green-download-icon cursor-pointer ml-2'
                                            data-tip="Download Report" onClick={() => this.onClickDownloadPdf("CLASS_PERFORMANCE_REPORT", item, index)}
                                            src={getImageSource(ImageConstants.PDF_DOWNLOAD_ICON)} />
                                }
                            </div>
                            :
                            <></>
                    }
                </div>

                <div className='row flex-nowrap align-items-center'>
                    <div className='col-7 px-0'>
                        <div className='report-wrapper' onClick={() => this.showReport("SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT", item, index)}>
                            <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                            <span className={`${item.completed ? "blue" : ""}`}>{`Class Performance Report`}</span>
                        </div>
                    </div>
                    {
                        item.completed ?
                            <div className='col-5 download-icon-wrapper d-flex align-items-center'
                            >
                                <img className='report-icon' />

                                {
                                    this.state.isPdfLoading && this.state.selectedIndex === index &&
                                        this.state.selectedReportType === 'SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT' ? <FontAwesomeIcon size="2x" icon={faSpinner} spin /> :
                                        <img className='green-download-icon cursor-pointer ml-2'
                                            data-tip="Download Report" onClick={() => this.onClickDownloadPdf("SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT", item, index)}
                                            src={getImageSource(ImageConstants.PDF_DOWNLOAD_ICON)} />
                                }


                            </div>
                            :
                            <></>
                    }
                </div>

                {/* <div className='row flex-nowrap align-items-center'>
                    <div className='col-7 px-0'>
                        <Link to={{ pathname: Path.STUDENT_LOGOUT_REPORT, state: { board: item.board, class: item.class, section: item.section, subject: item.subjectName || item.subject || 'Mathematics', chapter: (Array.isArray(item.chapters) && item.chapters.length > 0 ? (typeof item.chapters[0] === 'object' ? (item.chapters[0].title || item.chapters[0].name || '') : item.chapters[0]) : (item.chapterTitle || item.chapterName || item.chapter || item.title || '')), homeworkId: typeof item._id === 'object' ? (item._id.$oid || item._id.toString()) : (item._id || item.homeworkId || item.id || ''), autoFetch: true } }} style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className='report-wrapper'>
                                <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                                <span className="blue">{`Student Logout Report`}</span>
                            </div>
                        </Link>
                    </div>
                    <div className='col-5 px-0'>
                        <div className='d-flex align-items-center'>
                            <img 
                                data-tip={"Export to Excel"} 
                                className='report-icon cursor-pointer' 
                                src={getImageSource(ImageConstants.EXPORT_TO_EXCEL)} 
                                onClick={() => this.onClickDownloadLogoutReport(item)}
                            />
                        </div>
                    </div>
                </div> */}

                {
                    item.chapters && item.chapters.length > 1 && item.completed ?
                        <div className='row flex-nowrap align-items-center'>
                            <div className='col-7 px-0' onClick={() => this.showDiagnosticAssessmentReport(item, index)}>
                                <div className='report-wrapper'>
                                    <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION)} />
                                    <span className={`${this.state.activeTabIndex != 0 ? "blue" : "blue"}`}>Diagnostic Assessment Report</span>
                                </div>
                            </div>
                        </div>
                        :
                        <></>
                }





            </div>
        )
    }

    getActions = (item, index) => {

        return (
            <div className="text-right">
                {
                    this.accessRights[AccessRights.TEST_ARCHIVED]
                        ? <>
                            <img className='action-icon cursor-pointer' id={`rchived-tooltip-${index}`} src={getImageSource(ImageConstants.ARCHIVE)} onClick={() => this.setState({ showArchiveModal: true, selectedHomework: item })} />
                            <Tooltip className={`${this.state.tooltipOpenIndex === index ? "show" : "hide-tooltip"}`} placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={`rchived-tooltip-${index}`} toggle={() => { this.setState({ tooltipOpen: !this.state.tooltipOpen, tooltipOpenIndex: index }) }}>
                                Archive
                            </Tooltip>
                        </>
                        : ""
                }
                <span className="pl-4">
                    {
                        this.accessRights[AccessRights.TEST_REMINDER] ?
                            <>
                                <img className='action-icon cursor-pointer' id={`reminder-tooltip-${index}`} src={getImageSource(ImageConstants.REMAINDER)} onClick={() => this.onClickReminderModal(item)} />
                                <Tooltip className={`${this.state.reminderToolTipIndex === index ? "show" : "hide-tooltip"}`} placement="top" isOpen={this.state.reminderTooltipOpen} autohide={false} target={`reminder-tooltip-${index}`} toggle={() => { this.setState({ reminderTooltipOpen: !this.state.reminderTooltipOpen, reminderToolTipIndex: index }) }}>
                                    Reminder
                                </Tooltip>
                            </>
                            : ""
                    }
                </span>
            </div>
        )

    }

    getActivateHomework = (item) => {

        return (
            <div className='text-right' >

                {
                    this.accessRights[AccessRights.TEST_ACTIVE] ?
                        <span className='cursor-pointer' onClick={() => this.setState({ showActiveConfirmationModal: true, selectedHomework: item })}>Mark As Active</span>
                        : <></>
                }


            </div>
        )

    }



    renderNotificationIcons(item) {
        return (
            <div className="notification-icons">
                <span className="pt-2 mr-2">
                    <img className="icon-20 cursor-pointer" src={getImageSource(ImageConstants.EMAIL)} onClick={() => this.onCLickNotitification(item, "EMAIL")} />
                </span>
                <span className="pt-2">
                    <img className="icon-20 cursor-pointer" src={getImageSource(ImageConstants.WHATSAPP)} onClick={() => this.onCLickNotitification(item, "WHATSAPP")} />
                </span>
                {/* <div className="pt-2">
                    <img className="icon-20 cursor-pointer" src={getImageSource(ImageConstants.SMS)} onClick={() => this.onCLickNotitification(item, "SMS")} />
                </div>
                <div className="pt-2">
                    <img className="icon-20 cursor-pointer" src={getImageSource(ImageConstants.CLONE)} />
                </div> */}
            </div>
        )
    }

    renderUserList(item) {
        console.log(item)
        return (
            <div className='students-card' ref={ref => this.studentRef = ref}>

                <div className="row">
                    <div className="col">
                        <img className="close-icon cursor-pointer" onClick={(event) => this.onHideUserList()} src={getImageSource(ImageConstants.CROSS)} />
                    </div>
                </div>

                {
                    item?.users?.length ? item.users.map((user, index) =>
                        <div className='px-4 py-2 row align-items-center'>
                            <div className="profile-avatar text-center mr-2 d-inline-block">
                                <div className="row justify-content-center">
                                    {user?.image ? <img className="" alt="img" src={`${item.basePath}${user.image}`} />
                                        :
                                        <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                </div>
                            </div>
                            <div className='student-name ml-2'>
                                {user?.name}
                            </div>
                        </div>

                    )
                        :
                        <div className="text-center pt-4">No Records Found</div>
                }
            </div>
        )
    }

    getHomeworkCard = (item, index, groupIndex) => {

        return (
            <div className='homework-card'>
                <div className=''>
                    <div className='row'>
                        <div className='col d-flex align-items-center'>
                            <div>
                                <img className='chapter-icon' src={getImageSource(ImageConstants.CHAPTER_ICN)} />
                            </div>
                            <div className='pl-2'>
                                {
                                    this.state.userInfo.subjectId === Constants.SCIENCE_SUBJECTID ?
                                        <div className='body-sub-title pt-1'>
                                            <div>
                                                <strong>{`${item.clickerAssessmentTitle ? item.clickerAssessmentTitle : item.subSubjectName}, `}</strong>
                                                <strong>{item.chapters?.map(chapter => (
                                                    <div className='body-sub-title'><strong>{chapter.title}</strong>
                                                    </div>
                                                ))}</strong>
                                            </div>
                                        </div>
                                        :
                                        <div className='body-sub-title pt-1'>
                                            <strong>{item.chapters?.map(chapter => (
                                                <div className='body-sub-title pt-2'><strong>{chapter.title}</strong>
                                                </div>
                                            ))}</strong>
                                        </div>
                                }

                                {
                                    CommonUtils.isOnline() && item.isDownloaded && (this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' || this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Completed') ?
                                        <div className='body-title'>{item.board}, {item.class} {item.section} {`${(item.teacherHomeworkActivityStatus === 'IN_PROGRESS' || item.teacherHomeworkActivityStatus === 'COMPLETED') ? `, Clicker ${item.selectedSetTitle}` : ""}`} </div>
                                        :
                                        <div className='body-title'>{item.board}, {item.class.replace('Class ', '')} {item.section} {`${(item.teacherHomeworkActivityStatus === 'IN_PROGRESS' || item.teacherHomeworkActivityStatus === 'COMPLETED') ? `, Clicker ${item.selectedSetTitle}` : ""}`}</div>
                                }

                                {/* <div className='body-title'>{item.board}, {item.class} {item.section}</div> */}
                            </div>
                        </div>
                    </div>

                    <div className='created-date'>
                        Created On : {this.getDate(item.createdDateTimestamp, true)}
                    </div>

                    {
                        CommonUtils.isOnline() && item.teacherHomeworkActivityStatus === 'COMPLETED' ?
                            <div className='completed-date'>
                                Completed On : {this.getDate(item.countingwellLastUpdateTimestamp, true)}
                            </div>
                            :
                            <></>
                    }

                    <div className='question-wrapper mt-4 mb-4 d-flex align-items-center '>
                        <div className='d-flex align-items-center border-right-for-question pr-2'>
                            <img className='question-mark-icon' src={getImageSource(ImageConstants.QUESTION_MARK)} />
                            <span className='pl-2 question-count'>{item.questions}</span>
                        </div>
                        <div className='d-flex align-items-center pl-2 border-right-for-question pr-2'>
                            <img className='question-mark-icon' src={getImageSource(ImageConstants.CLOCK_IMAGE)} />
                            <span className='pl-2 question-count'>{item.time}</span>
                        </div>
                        <div className='d-flex align-items-center pl-2'>
                            <img className='question-mark-icon' src={getImageSource(ImageConstants.CLOCK_IMAGE)} />
                            <span className='pl-2 question-count'>{item.totalMarks ? item.totalMarks : '-'}</span>
                        </div>
                    </div>

                    {/* <div className='leader-board-wrapper mb-3 d-flex align-items-center'>
                            <div className='show-timer-wrapper d-flex align-items-center'>
                                <img className="status-image" src={getImageSource(item.showTimer ? ImageConstants.CORRECT : ImageConstants.WRONG)} />
                                <img className="clock-image ml-1" src={getImageSource(ImageConstants.CLOCK_IMAGE)} />
                            </div>
                            <div className='show-timer-wrapper d-flex align-items-center ml-2'>
                                <img className="status-image" src={getImageSource(item.showLeaderboard ? ImageConstants.CORRECT : ImageConstants.WRONG)} />
                                <img className="clock-image ml-1" src={getImageSource(ImageConstants.LEADER_BOARD_BLOCK)} />
                                {
                                    item.showLeaderboard ? <span className='leader-board-text'>{item.leaderboardLimit == "5" ? 'Top 5' : item.leaderboardLimit === "10" ? 'Top 10' : item.leaderboardLimit === "ALL" ? 'ALL' : ''}</span> : <></>
                                }
                            </div>
                        </div> */}
                    {
                        item.schoolAssessmentId ?
                            <div className='school-assessmentid-text-wrapper position-relative'>
                                <span className='school-assessmentid-text cursor-pointer'
                                    data-tip={"Copy"}
                                    onClick={() => this.handleCopy(item.schoolAssessmentId)}>{item.schoolAssessmentId}</span>
                                <img className='copy-icon-size'
                                    data-tip={"Copy"}
                                    onClick={() => this.handleCopy(item.schoolAssessmentId)}
                                    src={getImageSource(ImageConstants.COPY_ICON)} />
                                {this.state.copiedId === item.schoolAssessmentId && (
                                    <div className="copied-tooltip">
                                        Copied!
                                    </div>
                                )}
                            </div>
                            :
                            <></>
                    }

                </div>

            </div>
        )

    }

    onClickSync(homeworkItem, callback) {
        console.log(homeworkItem)
        dbHelper.getAllFromIndex(Constants.USER_ASSESSMENT_ACTIVITY_STORE, 'schoolAssessmentId', homeworkItem._id).then(activity => {
            console.log(activity)
            let payload = {
                activity,
                homeworkId: homeworkItem._id
            }
            HomeworkApi.syncOfflineUserAssessmentActivity(payload).then(synCompletedRes => {
                callback(null, true)
            })
        }).catch(err => {
            console.log(err)
            callback(err, false)
        })
    }

    onClickDownload(item, callback) {
        // console.log(item)
        // console.log(dbHelper)

        let payload = {}

        payload.isFromMyHomework = true
        payload.homeworkActivityId = item.teacherHomeworkActivityId

        payload.board = item.board
        payload.class = item.class
        payload.sectionId = item.sectionId

        HomeworkApi.downloadOfflineUserAssessmentActivity(payload).then(response => {
            console.log(response)
            if (response.userAssessmentActivity.length && response.contentsList.length && response.clickerUserList.length) {
                item.isDownloaded = true
                item.schoolId = response.teacherHomeworkActivity[0].schoolId
                item.assessmentActivityId = response.assessmentActivityId
                // const urls = response.updatedImageObjects
                //     .map(image => {
                //         if (image.buffer && image.mimeType) {
                //             const blob = base64ToBlob(image.buffer, image.mimeType);
                //             return URL.createObjectURL(blob);
                //         }
                //         return null;
                //     })
                //     .filter(Boolean); // Filter out any null entries

                response.contentsList.forEach(contentItem => {
                    let content = contentItem.content
                    if (content.images && content.images.length) {
                        content.images.forEach(item => {
                            const [contentType, base64Data] = item.base64Data.split(';base64,');
                            const imageBlob = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                            delete item.base64Data
                            item.imageBlob = imageBlob

                        })
                    }

                    if (content.options && content.options.length) {
                        content.options.forEach(option => {
                            if (option.contentTypeName === 'IMAGE' && option.base64Data) {
                                const [contentType, base64Data] = option.base64Data.split(';base64,');
                                const imageBlob = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                                delete option.base64Data
                                option.imageBlob = imageBlob
                            }
                        })
                    }

                    // For Multi Step

                    if (content.isMultiStep && content.steps && content.steps.length) {
                        content.steps.forEach(stepContentItem => {
                            let stepContent = stepContentItem.content
                            if (stepContent.images && stepContent.images.length) {
                                stepContent.images.forEach(item => {
                                    const [contentType, base64Data] = item.base64Data.split(';base64,');
                                    const imageBlob = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                                    delete item.base64Data
                                    item.imageBlob = imageBlob
                                })
                            }

                            if (stepContent.options && stepContent.options.length) {
                                stepContent.options.forEach(option => {
                                    if (option.contentTypeName === 'IMAGE' && option.base64Data) {
                                        const [contentType, base64Data] = option.base64Data.split(';base64,');
                                        const imageBlob = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                                        delete option.base64Data
                                        option.imageBlob = imageBlob
                                    }
                                })
                            }

                        })
                    }
                })

                // const urls = response.updatedImageObjects.map((item) => {
                //     const images = item.images.map((item) => {
                //         const [contentType, base64Data] = item.base64Data.split(';base64,');
                //         const blobUrl = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                //         return { imageUrl: item.imageUrl, blobUrl }
                //     });
                //     return { id: item.id, images };
                // });

                // console.log(response.contentsList)

                // this.setState({ imageUrls: urls });

                let dataArray = [item]

                dbHelper.updateBulkData(Constants.HOMEWORK_STORE, dataArray).then(resHomework => {

                    dbHelper.updateBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, response.teacherHomeworkActivity).then(res => {
                        // console.log(res)
                        dbHelper.updateBulkData(Constants.USER_ASSESSMENT_ACTIVITY_STORE, response.userAssessmentActivity).then(activityRes => {
                            // console.log(activityRes)
                            dbHelper.updateBulkData(Constants.CONTENTS_STORE, response.contentsList).then(contentRes => {
                                console.log(contentRes)
                                // this.updateItem(item._id)
                                dbHelper.updateBulkData(Constants.CLICKER_USERS_STORE, response.clickerUserList).then(userListUpdatedRes => {
                                    console.log(userListUpdatedRes)
                                    callback(null, true)
                                })
                            })
                        })
                    })
                })
            }
            else {
                this.showToaster('error', `Due to Internet issue Assessment Not Downloaded`)
            }

        }).catch(err => {
            console.log(err)
            callback(err, false)
        })

        // Download the Data

        // dbHelper.addBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, dataArray).then(res => {
        //     console.log(res)
        // }).catch(err => {
        //     console.log(err)
        // })

        // To Get the Data from the DB

        // dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'type', 'JIGYASA_ASSESSMENT').then(res => {
        //     console.log(res)
        // }).catch(err => {
        //     console.log(err)
        // })

        // dbHelper.getAllFromIndex(Constants.USER_ASSESSMENT_ACTIVITY_STORE, 'schoolAssessmentId', item.homeworkId).then(res => {
        //     console.log(res)
        // }).catch(err => {
        //     console.log(err)
        // })

        // dbHelper.getAllData(Constants.CONTENTS_STORE).then(res => {
        //     console.log(res)
        // }).catch(err => {
        //     console.log(err)
        // })


    }

    base64ToBlobUrl = (base64Data, contentType) => {
        // Decode base64 to binary
        const binaryData = atob(base64Data);
        const byteArray = new Uint8Array(binaryData.length);

        // Create an array of 8-bit unsigned integers to hold binary data
        for (let i = 0; i < binaryData.length; i++) {
            byteArray[i] = binaryData.charCodeAt(i);
        }

        // Create Blob from byte array
        const blob = new Blob([byteArray], { type: contentType });
        // return URL.createObjectURL(blob);
        return blob;
    };


    updateItem = (id, homeworkItem, type) => {


        if (type === 'DOWNLOAD') {

            this.setState((prevState) => ({
                testList: prevState.testList.map((item) =>
                    item._id === id ? { ...item, isDownloading: true } : item
                )
            }));

            console.log(this.state.content)

            this.onClickDownload(homeworkItem, (err, res) => {
                // console.log(res)
                if (res) {
                    this.showToaster('info', `Assessment Downloaded Successfully`)
                    this.teacherHomeworkActivityStatusHash[homeworkItem._id]['isDownloaded'] = true
                    // this.teacherHomeworkActivityStatusHash[homeworkItem._id]['isPresentInThisSystem'] = true
                    this.setState((prevState) => ({
                        testList: prevState.testList.map((item) =>
                            item._id === id ? { ...item, isDownloaded: true, isDownloading: false } : item
                        )
                    }));
                }
            })
        }

        if (type === 'SYNC') {

            if (!CommonUtils.isOnline()) return

            let teacherHomeworkActivityId = homeworkItem.teacherHomeworkActivityId

            dbHelper.getData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, teacherHomeworkActivityId).then(teacherActivity => {

                if (!teacherActivity.pendingSync) {
                    alert('Already Sync Completed')
                    return;
                }

                this.setState((prevState) => ({
                    testList: prevState.testList.map((item) =>
                        item._id === id ? { ...item, isDownloaded: true, pendingSync: true, isSynchronizing: true } : item
                    )
                }));

                // console.log(homeworkItem)

                this.onClickSync(homeworkItem, (err, res) => {
                    // console.log(res)
                    // homeworkItem.pendingSync = false
                    // console.log(homeworkItem)
                    // let dataArray = [homeworkItem]
                    // console.log(teacherActivity)

                    teacherActivity.pendingSync = false

                    teacherActivity = [teacherActivity]

                    dbHelper.updateBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, teacherActivity).then(updateTeacherActivityRes => {

                        if (res) {
                            this.showToaster('info', `Synced Successfully`)

                            this.teacherHomeworkActivityStatusHash[homeworkItem._id]['pendingSync'] = false
                            this.getTeacherHomeworkActivities()
                            this.setState((prevState) => ({
                                testList: prevState.testList.map((item) =>
                                    item._id === id ? { ...item, isDownloaded: true, pendingSync: false, isSynchronizing: false } : item
                                )
                            }, () => {
                                console.log('called Teacher Homework Activity')
                                // this.getTeacherHomeworkActivities()
                            }));
                        }
                    }).catch(err => {
                        console.log(err)
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    };

    getAllQuestionsReportPdf(item, index) {

        let payload = {
            isPdfGeneration: true
        }

        this.setState({ allQuestionsReportIndex: index, allQuestionsReportLoading: true })
        payload.assessmentId = item._id
        payload.chapterTitle = item.chapter ? item.chapter : ""
        TestApi.getAllQuestionList(payload)
            .then(response => {
                this.setState({ allQuestionsReportLoading: false })
                this.downloadPDF(response.link, "All Question Report PDF")
            }).catch(err => {
            })
    }

    renderTableRow(item, index) {

        const isOnline = CommonUtils.isOnline()

        return (
            <div onMouseEnter={ReactTooltip.rebuild} id={item._id} key={item._id} className={`tr-divider mb-4 mt-5 row pr-0 ${index === this.state.selectedItemIndex ? "tr-bg-color" : ''}`}>
                <div className='col-4 pt-2'>
                    {this.getHomeworkCard(item)}
                </div>
                {
                    // item.status === 'DRAFT' ?
                    //     <>
                    //         <div className={`col-2 pt-3 ${isOnline ? "" : "pb-3"}`}>
                    //             {
                    //                 CommonUtils.isOnline() ?
                    //                     <div className="" >
                    //                         {
                    //                             this.state.questionLoading && this.state.questionLoadingIndex === index && this.state.questionLoadingGroupIndex === 0 ?
                    //                                 <FontAwesomeIcon size="2x" icon={faSpinner} spin />
                    //                                 :
                    //                                 <img alt="" className="hambargur-icon cursor-pointer" src={getImageSource(ImageConstants.HANBARGUR_NEW)} onClick={() => this.onClickQuestionList(item, index, 0)} />
                    //                         }
                    //                     </div>
                    //                     :
                    //                     <></>
                    //             }

                    //             <div className='button-wrapper cursor-pointer mb-3 mt-4' style={{ background: '#21b8c7' }} onClick={() => this.onClickNewHomeWork(item, index, true)}>
                    //                 <div className='start-button'>Assign Practice</div>
                    //             </div>
                    //         </div>


                    //     </>

                    // :
                    <>
                        <div className={`col-2 pt-3 ${isOnline ? "" : "pb-3"}`}>
                            {
                                CommonUtils.isOnline() ?
                                    <div className="d-flex align-items-center" onMouseEnter={ReactTooltip.rebuild} >
                                        <div>
                                            {
                                                this.state.questionLoading && this.state.questionLoadingIndex === index && this.state.questionLoadingGroupIndex === 0 ?
                                                    <FontAwesomeIcon size="2x" icon={faSpinner} spin />
                                                    :
                                                    <img alt="" className="hambargur-icon cursor-pointer" data-tip={'Questions List'} src={getImageSource(ImageConstants.HANBARGUR_NEW)} onClick={() => this.onClickQuestionList(item, index, 0)} />
                                            }
                                        </div>

                                        {
                                            <div className='pl-1 ml-4'>
                                                <img alt="" className="icon-30 cursor-pointer" data-tip={'Students List'} src={getImageSource(ImageConstants.USER1)} onClick={() => this.onClickUserList(index, null, item)} />
                                                {/* <div className="pl-4">
                                                            {
                                                                this.state.userListIndex === index ? this.renderUserList(item) : ""
                                                            }
                                                        </div> */}
                                            </div>
                                        }
                                        {
                                            item.completed ?
                                                <>
                                                    {
                                                        this.state.allQuestionsReportLoading && this.state.allQuestionsReportIndex === index ?
                                                            <FontAwesomeIcon className='ml-4' size="2x" icon={faSpinner} spin />
                                                            :
                                                            <img data-tip={"Download All Questions Report"} className='ml-4 review-answers-icon mt-1 cursor-pointer' onClick={() => this.getAllQuestionsReportPdf(item, index, 0)} src={getImageSource(ImageConstants.WRONG_QUESTIONS)} />
                                                    }
                                                </>
                                                :
                                                <></>
                                        }
                                    </div>
                                    :
                                    <></>
                            }

                            {
                                !CommonUtils.isOnline() ?
                                    <div>
                                        {
                                            <div className='pl-1 ml-2'>
                                                <img alt="" className="icon-30 cursor-pointer" src={getImageSource(ImageConstants.USER1)} onClick={() => this.onClickUserList(index, null, item)} />
                                                {/* <div className="pl-4">
                                                            {
                                                                this.state.userListIndex === index ? this.renderUserList(item) : ""
                                                            }
                                                        </div> */}
                                            </div>
                                        }
                                    </div>
                                    :
                                    <></>
                            }

                            {
                                Constants.ELECTRON_BUILD ?
                                    <div className='button-wrapper cursor-pointer mb-3 mt-4' style={{ background: '#21b8c7' }} onClick={() => this.onClickTestClicker(item, index)}>
                                        <div className='start-button'>Test Clickers</div>
                                    </div>
                                    :
                                    <div className='button-wrapper mb-3 mt-4' onMouseEnter={ReactTooltip.rebuild} style={{ background: '#A3A3A3', border: '#A3A3A3' }}>
                                        <div data-tip={'Use Countingwell Application'} className='start-button'>Test Clickers</div>
                                    </div>


                            }
                            <div className='d-flex mb-2' onMouseEnter={ReactTooltip.rebuild}>
                                {
                                    CommonUtils.isOnline() && item.isDownloaded && this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' ?
                                        <div className={`button-wrapper cursor-pointer`} onClick={() => this.onClickCard(item, index)}>
                                            <div className='start-button'>{'Resume Offline'}</div>
                                        </div>
                                        :
                                        Constants.ELECTRON_BUILD ?
                                            <div className={`button-wrapper cursor-pointer ${this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' ? "resume-bg" : ""}`} onClick={() => this.onClickCard(item, index)}>
                                                <div className='start-button'>{this.getButtonTitle(item.teacherHomeworkActivityStatus)}
                                                    {/* {this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' && item.resumeQuestionNumber ? ` (${item.resumeQuestionNumber}/${item.questions})` : ''} */}
                                                </div>
                                            </div>
                                            :
                                            <div data-tip={'Use Countingwell Application'} className={`button-wrapper-disabled ${this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' ? "resume-bg" : ""}`}>
                                                <div className='start-button'>{this.getButtonTitle(item.teacherHomeworkActivityStatus)}</div>
                                            </div>
                                }
                            </div>
                            {/* {
                                !item.isDownloaded && this.getButtonTitle(item.teacherHomeworkActivityStatus) === 'Resume' && CommonUtils.isOnline() ?
                                    <div className='d-flex pt-2'>
                                        <div className='button-wrapper cursor-pointer' style={{ background: '#F1685A' }} onClick={() => this.onClickEndPractice(item, index)}>
                                            <div className='start-button'>{"End Practice"}</div>
                                        </div>
                                    </div>
                                    :
                                    <></>
                            } */}
                            <div className="download-options" >
                                <div className="d-flex justify-content-start button-padding mb-2" onMouseEnter={ReactTooltip.rebuild}>
                                    {
                                        item.isDownloading ?
                                            <div className="view-answer-wrapper" style={{ background: '#407BFF', border: '#407BFF' }}>
                                                <div className="d-flex align-items-center justify-content-center view-answer-button">
                                                    <FontAwesomeIcon size="2x" icon={faSpinner} spin />
                                                    {/* <img className="download-icon-size mr-1" src={getImageSource(ImageConstants.DOWNLOAD_ICON_WHITE)} /><span>{'Downloading...'}</span> */}
                                                </div>
                                            </div>
                                            :
                                            item.isDownloaded ?
                                                <div className="view-answer-wrapper" style={{ background: '#A3A3A3', border: '#A3A3A3' }}>
                                                    <div className="d-flex align-items-center justify-content-center view-answer-button" >
                                                        <img className="download-icon-size mr-1" src={getImageSource(ImageConstants.DOWNLOAD_ICON_WHITE)} /><span>{'Downloaded'}</span>
                                                    </div>
                                                </div>
                                                :
                                                !item.isDownloaded && (item.teacherHomeworkActivityStatus === 'COMPLETED' || item.teacherHomeworkActivityStatus === 'IN_PROGRESS') ?
                                                    <></>
                                                    :
                                                    Constants.ELECTRON_BUILD ?
                                                        <div className="view-answer-wrapper" style={{ background: '#407BFF', border: '#407BFF' }}>
                                                            <div className="d-flex align-items-center justify-content-center view-answer-button cursor-pointer" onClick={() => this.updateItem(item._id, item, "DOWNLOAD")}>
                                                                <img className="download-icon-size mr-1" src={getImageSource(ImageConstants.DOWNLOAD_ICON_WHITE)} /><span>{'Download'}</span>
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className="view-answer-wrapper" style={{ background: '#A3A3A3', border: '#A3A3A3' }}>
                                                            <div data-tip={'Use Countingwell Application'} className="d-flex align-items-center justify-content-center view-answer-button " >
                                                                <img className="download-icon-size mr-1" src={getImageSource(ImageConstants.DOWNLOAD_ICON_WHITE)} /><span>{'Download'}</span>
                                                            </div>
                                                        </div>
                                    }
                                </div>
                                {
                                    item.isDownloaded ?
                                        <div className="d-flex justify-content-start button-padding">

                                            {
                                                item.isSynchronizing ?
                                                    <div className="view-answer-wrapper" style={{ background: '#96f2b7', border: '#96f2b7' }}>
                                                        <div className="text-center view-answer-button">
                                                            {/* {'Synchronizing...'}
                                                                     */}
                                                            <FontAwesomeIcon size="2x" icon={faSpinner} spin />
                                                        </div>
                                                    </div>
                                                    :
                                                    item.pendingSync && item.teacherHomeworkActivityStatus === 'COMPLETED' ?
                                                        <div className={`view-answer-wrapper ${isOnline ? 'syn-online-button' : 'light-gray-button'} `}>
                                                            <div className={`text-center view-answer-button ${isOnline ? 'cursor-pointer' : ''} `} onClick={() => this.updateItem(item._id, item, "SYNC")}  >
                                                                {'Sync Pending'}
                                                            </div>
                                                        </div>
                                                        :
                                                        !item.pendingSync && item.teacherHomeworkActivityStatus === 'COMPLETED' ?
                                                            <div className="view-answer-wrapper" >
                                                                <div className="text-center view-answer-button" >
                                                                    {'Sync Completed'}
                                                                </div>
                                                            </div>
                                                            :
                                                            <></>
                                            }
                                        </div>
                                        :
                                        <></>
                                }
                            </div>

                        </div>
                        <div className='col-2 pt-3 pl-3'>
                            <div className='status-text position-relative'>
                                Status
                            </div>

                            {
                                CommonUtils.isOnline() ?
                                    <>
                                        {/* <div className='mt-1 ml-2' >
                                            <img className='clone-icon cursor-pointer' data-tip={"Clone Assignment"}
                                                src={getImageSource(ImageConstants.CLONE_ICON)}
                                                onClick={() => this.setState({ showClickerAssignModal: true, selectedHomework: item })} />
                                        </div> */}

                                        {
                                            !item.completed ?
                                                <div ><img data-tip={"Delete Assignment"}
                                                    className='delete-icon cursor-pointer'
                                                    src={getImageSource(ImageConstants.DELETE_RED)}
                                                    onClick={() => this.setState({ showDeletionModal: true, selectedHomework: item })} /></div>
                                                :
                                                <></>

                                        }
                                    </>
                                    :
                                    <></>
                            }


                            <div>
                                {this.renderStatus(item, index)}
                            </div>
                        </div>
                        {
                            CommonUtils.isOnline() ?
                                <div className='col pr-0 pt-1 reports-border-left'>
                                    <div className='reports-text position-relative'>
                                        Reports
                                        {/* {
                                                    !item.baseLineHomeworkId ?
                                                        <div className='cursor-pointer' onClick={() => this.onClickNewHomeWork(item, index, false, true)}>Create Finish Line</div>
                                                        :
                                                        <></>
                                                } */}
                                        {/* {
                                            !item.completed ?
                                                <div ><img data-tip={"Delete Assignment"}
                                                    className='delete-icon cursor-pointer'
                                                    src={getImageSource(ImageConstants.DELETE)}
                                                    onClick={() => this.setState({ showDeletionModal: true, selectedHomework: item })} /></div>
                                                :
                                                <></>

                                        } */}

                                    </div>
                                    {
                                        item.completed ?
                                            <div className='mb-2 ml-3'>
                                                {this.getReportList(item, index)}
                                            </div>
                                            :
                                            <div className='mb-2 ml-3 text-center'>
                                                No Reports Available. Please Complete this Practice to See the Reports
                                            </div>

                                    }
                                    {/* <div className='mb-2 ml-3'>
                                        {this.getReportList(item, index)}
                                    </div> */}
                                </div>
                                :
                                <div className='col pr-0 pt-1 reports-border-left'>
                                    <div className='reports-text'>
                                        Reports
                                    </div>
                                    <div className='mb-2 ml-3 text-center'>
                                        Available in Online
                                    </div>
                                </div>
                        }
                    </>

                }


            </div>
        )
    }

    renderList = () => {

        // console.log(this.state.testList)

        return (
            <div className='tabs-wrapper'>
                <div className='screen-title mt-3'>Classroom Assessment</div>
                <div className='tabs ml-5'>
                    {this.getTabs()}
                </div>
                {
                    this.state.testList && this.state.testList.length ? this.state.testList?.map((item, index) => (
                        this.renderTableRow(item, index)
                    ))
                        : <div className="bg-white p-4 no-records-text"><div colSpan="5" align='center'>No Record's found</div></div>
                }
                {/* <div id="table-scoll" className="table-responsive mt-3">
                    <table className="table cw-table mb-0 align-items-center custom-test-table">
                        <thead>
                            <tr className='tr-divider-thin'>
                                <th className='th-left-radius test-text'>{this.props.type == "DIAGNOSTIC" ? "Chapter Readiness Test" : "Clicker Assessments List"} </th>
                                <th></th>
                                <th className="th-right-radius"></th>
                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {
                                this.state.testList && this.state.testList.length ? this.state.testList?.map((item, index) => (

                                    <tr key={item._id} className={`tr-divider ${index === this.state.selectedItemIndex ? "tr-bg-color" : ""}`}>
                                        <td>{this.getTestCard(item, index)}</td>
                                        <td>
                                            <span>{item.class} {item.section}</span>
                                            <div className='mt-4 pl-1'>
                                                <img alt="" className="icon-30 cursor-pointer" src={getImageSource(ImageConstants.USER1)} onClick={() => this.onClickUserList(index)} />
                                                <div className="pl-4">
                                                    {
                                                        this.state.userListIndex === index ? this.renderUserList(item) : ""
                                                    }
                                                </div>
                                            </div>

                                            <div className="mt-4 pl-1" >
                                                {
                                                    this.state.questionLoading && this.state.questionLoadingIndex === index ?
                                                        <FontAwesomeIcon size="2x" icon={faSpinner} spin />
                                                        :
                                                        <img alt="" className="icon-30 cursor-pointer" src={getImageSource(ImageConstants.BULLET_LIST)} onClick={() => this.onClickQuestionList(item, index)} />}
                                            </div>



                                        </td>
                                        <td>{this.renderStatus(item, index)}</td>

                                        <td>{this.getReportList(item, index)}</td>
                                       
                                    </tr>
                                ))
                                    : <tr className="bg-white pt-4"><td colSpan="5" align='center'>No Records found</td></tr>
                            }
                        </tbody>
                    </table>
                </div > */}
            </div>
        )
    }

    renderReport = () => {

        switch (this.state.selectedReportType) {

            case "ELO_LEVEL_REPORT":
                return <EloReport type={this.props.type} delegate={this} selectedItem={this.state.selectedItem} />

            case "RECOMMANDATION_REPORT":
                return <RecommandationReport type="TEST" show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport} selectedItem={this.state.selectedItem} />

            case "CLASS_PERFORMANCE_REPORT":
                return <ClassPerformanceReport
                    delegate={this}
                    close={this.hideReport}
                    selectedItem={this.state.selectedItem}
                />

            case "SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT":
                return <SchoolworkOverallClassPerformanceReport
                    delegate={this}
                    close={this.hideReport}
                    selectedItem={this.state.selectedItem}
                />

            case "HOMEWORK_EVALUATION_REPORT":
            // return <TestProgressionReport delegate={this} />
            // return <TestEvalutionReport delegate={this} />

            default:
                return ""
        }
    }

    onClickDownloadLogoutReport = (item) => {
        let payload = {
            board: item.board,
            class: item.class,
            section: item.section,
            homeworkId: typeof item._id === 'object' ? (item._id.$oid || item._id.toString()) : (item._id || item.homeworkId || item.id || '')
        };
        SchoolApi.getStudentLogoutReport(payload)
            .then(res => {
                const blob = new Blob([res], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = 'student-logout-report.csv';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }).catch(err => {
                console.log(err);
                alert("Error downloading report.");
            });
    }

    renderFilters = () => {
        return (
            <div>{this.state.selectedFilters.map((filter, index) => (
                <div key={'filter' + index} className='selected-filter-container'>
                    <div className='filter-type'>{filter.type}</div>
                    <div className='filter-value'>{filter.value}</div>
                </div>
            ))}
            </div>
        )
    }

    hideCompletionReport = () => {
        this.hideReport()
        this.setState({ showCompletionReport: false })
    }

    // showTestResultsReport = (type, item, index) => {

    //     let teacherName = this.state.userInfo?.name
    //     let schoolName = this.state.userInfo?.schoolInfo?.name
    //     let city = this.state.userInfo?.schoolInfo?.address?.city
    //     let branch = this.state.userInfo?.schoolInfo?.address?.branch

    //     let pathname = `${type}${item._id}/${item.chapters[0].title}/${item.class}/${item.createdDateTimestamp}/${schoolName}/${teacherName}/${city}/${branch}`

    //     this.setState({ showTestResultReport: false, selectedItem: item, selectedItemIndex: index })

    //     let origin = window.location.origin

    //     window.open(origin + pathname)
    // }

    showTestResultsReport = (item, index) => {

        console.log(item)

        // let teacherName = this.state.userInfo?.name
        // let schoolName = this.state.userInfo?.schoolInfo?.name
        // let city = this.state.userInfo?.schoolInfo?.address?.city
        // let branch = this.state.userInfo?.schoolInfo?.address?.branch

        // let pathname = `${type}${item._id}/${item.chapters[0].title}/${item.class}/${item.createdDateTimestamp}/${schoolName}/${teacherName}/${city}/${branch}`

        this.setState({ showTestResultReport: true, selectedItem: item, selectedItemIndex: index })

        // let origin = window.location.origin

        // window.open(origin + pathname)
    }


    showDiagnosticAssessmentReport = (item, index) => {


        // let teacherName = this.state.userInfo?.name
        // let schoolName = this.state.userInfo?.schoolInfo?.name
        // let city = this.state.userInfo?.schoolInfo?.address?.city
        // let branch = this.state.userInfo?.schoolInfo?.address?.branch

        // let pathname = `${type}${item._id}/${item.chapters[0].title}/${item.class}/${item.createdDateTimestamp}/${schoolName}/${teacherName}/${city}/${branch}`

        this.getPerformanceReport(item, index)

        // this.setState({ showDiagnosticAssessmentReport: true, selectedItem: item, selectedItemIndex: index })

        // let origin = window.location.origin

        // window.open(origin + pathname)
    }


    getPerformanceReport(item, index) {
        console.log(item)

        if (item.teacherHomeworkActivityStatus != 'COMPLETED') return;

        let payload = {
            // board: this.state.selectedBoard,
            // class: this.state.selectedClass,
            // section: this.state.selectedSection,
            // type: this.state.selectedAssessmentType
            board: item.board,
            class: item.class,
            type: item.type,
            homeworkId: item._id,
            section: item.sectionId
        }

        this.setState({ isLoading: true })

        CommonApi.getPerformanceReport(payload).then(res => {
            console.log(res)
            let categories = this.state.categories

            categories.forEach(category => {

                if (category.type === 'NOVICE' && res.noviceStudents && res.noviceStudents.length) {
                    category.students = res.noviceStudents
                }

                if (category.type === 'PROFICIENT' && res.proficientStudents && res.proficientStudents.length) {
                    category.students = res.proficientStudents
                }

                if (category.type === 'ADVANCED' && res.advancedStudents && res.advancedStudents.length) {
                    category.students = res.advancedStudents
                }
            })

            this.setState({ showDiagnosticAssessmentReport: true, categories, reportData: res, selectedItem: item, selectedItemIndex: index, isLoading: false })
        }).catch(err => {
            this.setState({ isLoading: false })
            console.log(err)
        })
    }

    hideDiagnosticAssessmentReport() {
        this.setState({
            showDiagnosticAssessmentReport: false, isLoading: false, reportData: {},
            categories: [
                {
                    type: "NOVICE",
                    title: "Novice",
                    maxPercentage: 50,
                    students: [],
                    colorClass: "purble-header",
                    selectedCriterion: 1
                },
                {
                    type: "PROFICIENT",
                    title: "Proficient",
                    minPercentage: 50,
                    maxPercentage: 80,
                    students: [],
                    colorClass: "orange-header",
                    selectedCriterion: 1
                },
                {
                    type: "ADVANCED",
                    title: "Advanced",
                    minPercentage: 80,
                    students: [],
                    colorClass: "litebule-header",
                    selectedCriterion: 1
                }
            ]
        })
    }



    hideTestResultsReport = () => {
        this.hideReport()
        this.setState({ showTestResultReport: false })
    }

    onGoFilter = (payload = {}) => {
        this.filter = {
            status: this.filter.status,
            page: this.filter.page,
            ...payload
        }
        this.getTestList(this.filter)
    }

    onPageSelected = (selectedPage, startIndex) => {
        this.startIndex = startIndex
        this.filter.page = selectedPage
        this.setState({ selectedPage, selectedItemIndex: null })
        this.getTestList(this.filter)
    }


    showQuestionList = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideQuestionList} size={'lg'}>
                <ModalBody >
                    <QustionsList selectedItem={this.state.selectedItem} delegate={this} close={this.hideQuestions} />
                </ModalBody>
            </Modal>
        )
    }

    showSuccessMessage() {
        this.hideNewTest(true)
        this.showToaster('info', "Assessment Created successfully")
    }

    render() {

        if (this.state.showReport) {
            return this.renderReport()
        }

        if (this.state.showNewTest)
            return <NewTest
                delegate={this}
                type={this.state.type}
                selectedHomework={this.state.selectedHomework}
                isClonePractice={this.state.isClonePractice ? true : false}
            />

        if (this.state.showViewSummary) {
            return <ViewAssessmentSummary delegate={this} type="CLICKER_ASSESSMENT" />
        }

        if (this.state.showCompletionReport)
            return <CompletionReport selectedItem={this.state.selectedItem} delegate={this} />

        if (this.state.showTestResultReport)
            return <TestResultReport selectedItem={this.state.selectedItem} delegate={this} />

        if (this.state.showAllQuestions)
            return <AllQuestions selectedItem={this.state.selectedItem} delegate={this} close={this.hideQuestions} />


        if (this.state.showWrongAnswersReport)
            return <WronglyAnswered type="TEST" show={this.state.showWrongAnswersReport} selectedItem={this.state.selectedItem} delegate={this} close={this.hideWrongAnswersReport} />


        if (this.state.showAssessmentFlow) {
            return <JigyasaAssessment meta={this.state.teacherHomeworkItem} delegate={this} />
        }

        if (this.state.showDiagnosticAssessmentReport) {
            return <DiagnosticAssessmentReport delegate={this}
                class={this.state.selectedItem.class ? this.state.selectedItem.class : 'Class 10'}
                sectionName={this.state.selectedItem.section}
                reportData={{ categories: this.state.categories, ...this.state.reportData }}
                reportType={''} />
        }

        if (this.state.showTestClickerScreen && CommonUtils.isOnline()) {
            return <ClickerTesting delegate={this} selectedItem={this.state.selectedItem} />
        } else if (this.state.showTestClickerScreen && !CommonUtils.isOnline()) {
            return <ClickerTesting delegate={this}
                selectedItem={this.state.selectedItem} studentList={this.state.studentList} />
        }



        if (this.state.showUsersList) {
            return <StudentNameList delegate={this} selectedItem={this.state.selectedItem} />
        }



        return (
            <>
                {
                    // this.state.isLoading ? <Loading /> :
                    <div className='clicker-assessment-list-screen-new'>
                        <div className='row'>
                            <div className="col">
                                <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                            </div>
                            <div className="col text-right">
                                {
                                    this.accessRights[AccessRights.TEST_CREATE] ?
                                        <button className='float-right cw-btn-md d-inline-block cw-btn-primary btn-min-width'
                                            onClick={() => this.onClickNewTest()}
                                            style={{ width: "18.8rem" }}>
                                            New Assessment
                                        </button>
                                        : ""
                                }

                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className="col text-right">
                                {
                                    this.accessRights[AccessRights.TEST_CREATE] ?
                                        <button className='float-right cw-btn-md d-inline-block cw-btn-primary btn-min-width' onClick={() => this.onClickViewSummary()}>
                                            View Assessment Summary
                                        </button>
                                        : ""
                                }
                            </div>
                        </div>

                        {/* <div className="row">
                                <div className='screen-title mt-3 col-10'>{this.props.type == "DIAGNOSTIC" ? "Chapter Readiness Test List" : "Clicker Assessment List"} </div>
                            </div> */}

                        <div className=' mt-3 mb-5'>
                            <Filter onGo={this.onGoFilter} filter={this.props.filter} />
                        </div>
                        {this.renderFilters()}

                        <div className=''>{this.renderList()}</div>
                        <div className='card-footer'>
                            {
                                this.state.meta?.totalPages ?
                                    <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta.totalPages} onPageSelected={this.onPageSelected.bind(this)} /> : ''
                            }
                        </div>
                        {/* {this.state.showWrongAnswersReport && <WronglyAnswered type="TEST" selectedItem={this.state.selectedItem} show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport} />} */}
                        {this.state.showReminderModal ? this.renderReminderModal() : ""}
                        {this.state.showNotification ? this.renderNotificationModal() : ""}
                        {this.state.showSuccess ? <SuccessComponent
                            type={this.state?.selectedItem?.type}
                            title="ASSESSMENT CREATED"
                            students={this.state?.selectedItem?.totalUsers || 0}
                            close={this.closeSuccess}
                            onOk={this.onInviteMoreStudent}
                            class={this.state?.selectedItem?.class}
                            section={this.state?.selectedItem?.section ? Object.values(this.state?.selectedItem?.section).join(',') : ''}
                        /> : ""}
                        {this.state.showArchiveModal && <ArchiveModal title="Are you sure you want to Archive this Assessment?" delegate={this} onOk={this.onOkArchiveModal} onClose={this.onCloseArchiveModal} selectedItem={this.state.selectedHomework} />}
                        {this.state.showActiveConfirmationModal && <ActiveHomeworkModal title="Are you sure you want to Mark this Assessment Active ?" delegate={this} onOk={this.onOkActiveModal} onClose={this.onCloseActiveModal} selectedItem={this.state.selectedHomework} />}
                        {this.state.showDeletionModal && <AssignmentDeletionComponent title={`Are you sure you want to Delete this Clicker Assessment`} delegate={this} onOk={this.onOkDeleteModal} onClose={this.onCloseDeleteModal} selectedItem={this.state.selectedHomework} />}
                        {this.state.showClickerAssignModal && <AssignmentDeletionComponent title={`Are you sure you want to Clone this Clicker Assessment`} isAssignPractice={true} delegate={this} onOk={this.onOkClickerAssignModal} onClose={this.onCloseClickerAssignModal} selectedItem={this.state.selectedHomework} />}
                        {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div> : ""}
                        {
                            this.state.showQuestionList ? this.showQuestionList() : ""
                        }
                    </div >
                }
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </>
        )
    }
}

export default TestList;